<template>
  <div>
    <label v-if="this.currentTreatment.libelle_technique  === 'ij_module_prevoyance'"><i>Pour créer un incident, basculer le dossier en traitement manuel</i></label>
    <button v-if="canAddIncident() && isTraitement('Principal') && !cantEditFicheDC(dossier)" class="btn mb-3 btn-primary btn-md" @click.prevent="addIncident('add')">Ajouter une action</button>
    <button v-if="canAddIncident() && isTraitement('Secondaire')" class="btn mb-3 btn-primary btn-md" @click.prevent="addIncident('closeAdd')">
      {{ getActionButtonLibelle() }}
    </button>
    <b-table id="table-incident" striped :items="items" :fields="fields" :tbody-tr-class="rowClass">
      <template #row-details="row" >
        {{ getDetailDpc(row.item) }}
      </template>
      <template v-slot:cell(dateCreation)="row">
        <span> {{ row.item.dateCreation }}</span>
      </template>
      <template v-slot:cell(sousStatut)="row">
        <span v-if="row.item.new_added">
          <b-form-select v-model="row.item.sousStatut" :options="sousStatusEnAttenteOptions" :disabled="!row.item.new_added" :class="{hasError: errors.incident !== ''}">
          </b-form-select>
          <span class="field-error">{{ errors.incident }}</span>
        </span>
        <span v-else>{{ row.item.statusPP.libelle_bo }} <b-button @click="row.item._showDetails = !row.item._showDetails" class="ml-3" size="sm" v-if="row.item.statusPP && row.item.statusPP.libelle_technique === 'en_attente_dpc'">{{ row.detailsShowing ? 'Cacher' : 'Voir'}} le détail</b-button></span>
      </template>
      <template v-slot:cell(traitementPP)="row">
        <span v-if="row.item.traitementPP" class="align-middle p-3">{{ row.item.traitementPP.libelle_court }}</span>
        <img v-if="row.item.traitementPP" class="pull-right" :src="getIconSrc('corner')" v-b-tooltip.hover :title="row.item.traitementPP.libelle">
      </template>
      <template v-slot:cell(criterePriorite)="row">
        <span> {{ getCriterePriorite() }}</span>
      </template>
      <template v-slot:cell(collaborateurCreateur)="row">
        <span> {{ row.item.collaborateurCreateur }}</span>
      </template>
      <template v-slot:cell(destinataire)="row">
        <span> {{ getDestinataire(row.item) }}</span>
      </template>
      <template v-slot:cell(collaborateurAffecte)="row">
        <span> {{ getCollaborateurPS(row.item) }}</span>
      </template>
      <template v-slot:cell(statut)="row">
        <b-form-select size="sm" v-if="!row.item.new_added && (row.item.sousStatut === statusDpc.id || row.item.sousStatut === statusDpcAffiliation.id)" v-model="row.item.statut" :options="statusOptions"
                       :disabled="!row.item.can_edit">
        </b-form-select>
        <div v-else>
          {{ getStatusPS(row.item) }}
        </div>
      </template>
      <template v-slot:cell(traitementPS)="row">
        <span v-if="row.item.traitementPS">{{ row.item.traitementPS.libelle_court }}</span>
        <img v-if="row.item.traitementPS" class="pull-right" :src="getIconSrc('corner')" v-b-tooltip.hover :title="row.item.traitementPS.libelle">
        <i class="icon fa fa-repeat fa-1-5x text-primary clickable align-middle mx-auto" v-if="showDpcAgain(row.item) && !cantEditFicheDC(dossier)" @click="getBackToDpc(row.item)" title="Repasser à 'En attente DPC'" style="margin: auto;"></i>
      </template>
      <template v-slot:cell(dateStatutPS)="row">
        <span> {{ row.item.dateStatutPS }}</span>
      </template>
      <template v-slot:cell(action)="row">
        <i class="icon fa fa-eye fa-1-5x mr-2 text-primary clickable" v-if="!isEmpty(row.item.resultatControle) || !isEmpty(row.item.commentaireControle)" @click="openIncidentAnomalieModal(row.item)" title="Ouvrir info qualité"></i>
        <i class="icon fa fa-address-card-o fa-1-5x mr-2 text-primary clickable" v-if="canShowAffiliation(row.item)" @click="showAffiliationFiche(row.item)" title="Consulter la fiche d'affiliation d'urgence"></i>
        <i class="icon fa fa-pencil fa-1-5x mr-2 text-primary clickable" v-if="canContinueAffiliation(row.item)" @click="showAffiliationForm(row.item)" title="Continuer la demande d'affiliation"></i>
        <i class="icon fa fa-pencil fa-1-5x mr-2 text-primary clickable" v-if="canEdit(row.item)" @click="row.item.can_edit = !row.item.can_edit" title="Changer le statut"></i>
        <i class="icon fa fa-upload fa-1-5x mr-2 text-primary clickable" v-if="canUpload(row.item) && !cantEditFicheDC(dossier)" @click="uploadCourrier(row.item, 'dpc')" title="Chargement du courrier envoyé au client"></i>
        <!-- <i class="icon fa fa-upload fa-1-5x mr-2 text-primary clickable" v-if="canUploadDbco(row.item)" @click="uploadCourrierDbco(row.item, 'dpc')" title="Chargement du courrier envoyé au client"></i> -->
        <!-- <i class="icon fa fa-upload fa-1-5x mr-2 text-primary clickable" v-if="showUploadDbco(row.item)" @click="uploadCourrier(row.item, 'dbco')" title="Chargement du courrier envoyé au client"></i> -->
        <i class="icon fa fa-envelope-open fa-1-5x mr-2 text-primary clickable" v-if="canContinue(row.item)" @click="continueDpc(row.item)" title="Continuer DPC"></i>
        <i class="icon fa fa-envelope-open fa-1-5x mr-2 text-primary clickable" v-if="canContinueReminder(row.item)" @click="continueReminder(row.item)" title="Continuer Relance"></i>
        <i class="icon fa fa-envelope-open fa-1-5x mr-2 text-primary clickable" v-if="canContinueDbco" @click="showMailDbco(row.item)" title="Continuer le mail de conformité"></i>
        <i class="icon fa fa-reply fa-1-5x mr-2 text-primary clickable" v-if="canDoReminder(row.item, false)" @click="doReminder(row.item, false)" title="Effectuer une relance"></i>
        <i class="icon fa fa-upload fa-1-5x mr-2 text-warning clickable" v-if="canDoReminder(row.item, true)" @click="doReminder(row.item, true)" title="Effectuer une relance annuelle"></i>
        <i class="icon fa fa-envelope mr-2 clickable" v-if="canSeeSentMail(row.item)" @click="viewSentMail(row.item)" title="Voir les mails déjà envoyés"></i>
        <i class="icon fa fa-envelope mr-2 clickable" v-if="canShowSentMailDbco(row.item)" @click="showSentMailDbco(row.item)" title="Voir le mail DBCO"></i>
        <i class="icon fa fa-check fa-1-5x mr-2 text-primary clickable" v-if="canValidateDbcoSansAr" @click="validateDbcoSansAr(row.item)" title="Valider la DBCO"></i>
        <i class="icon fa fa-trash mr-2 clickable text-danger" v-if="canDelete(row.item)" @click="deleteIncident(row.item)"  title="Supprimer l'incident"></i>
        <i class="icon fa fa-save fa-1-5x text-primary mr-2 clickable" v-if="row.item.can_edit && row.item.type !== 'closeAdd'" @click="save(row.item)" title="Enregistrer"></i>
        <i class="icon fa fa-save fa-1-5x text-primary mr-2 clickable" v-if="row.item.can_edit && row.item.type === 'closeAdd'" @click="closeAndSave(row.item)" title="Enregistrer"></i>
        <i class="icon fa fa-ban text-danger mr-2 clickable" v-if="canCancel(row.item)" @click="cancel(row.item)" title="Annuler l'incident"></i>
        <i class="icon fa fa-gear fa-1-5x text-primary mr-2 clickable" v-if="canSendArDbcoAgain" @click="sendArDbcoAgain(row.item)" title="Renvoyer l'AR avec les nouvelles informations de contact"></i>

        <!-- <i class="icon fa fa-print text-primary text-danger mr-2 clickable" @click="print(row.item)" title="print"></i> -->
      </template>
    </b-table>
    <b-row class="mt-4">
      <b-col sm="12">
        <b-form-group
          label="Commentaires"
          label-for="commentaire"
          :label-cols="2"
          :horizontal="true">
          <b-form-textarea
            id="commentaire"
            type="text"
            rows="3"
            max-rows="9"
            :disabled="isDisabled('commentaire')"
            v-model="myData.commentaire">
          </b-form-textarea>
        </b-form-group>
        <div v-if="displayAllComments" v-for="(element,key) in allComments" :key="key" class="mb-2">
          <div class="comment-bloc mb-1 p-2">
            <span style="color: #1c00ff">
              <i>Le {{formatDate(element.created_at)}}, par {{ element.gestionnaire.nom}} {{ element.gestionnaire.prenom}}</i>
            </span>
            <br>
            <span>{{element.commentaire}}</span>
          </div>
        </div>
        <div v-if="allComments.length > 0 && !displayAllComments" class="comment-bloc mb-1 p-2">
            <span style="color: #1c00ff">
              <i>Le {{formatDate(lastComment.created_at)}}, par {{ lastComment.gestionnaire.nom}} {{ lastComment.gestionnaire.prenom}}</i>
            </span>
          <br>
          <span>{{lastComment.commentaire}}</span>
        </div>
        <fieldset :hidden="cantEditFicheDC(dossier)">
          <div class="pull-right">
            <b-button @click="displayAllComments = !displayAllComments" class="mb-3">
              <span v-if="!displayAllComments">Voir les anciens commentaires</span>
              <span v-if="displayAllComments">Cacher les anciens commentaires</span>
            </b-button>
            <b-button @click="enregistrerCommentaire" class="mb-3 ml-2" variant="primary"><i class="fa fa-save"></i> Enregistrer le commentaire</b-button>
          </div>
        </fieldset>
      </b-col>
    </b-row>

    <b-modal centered no-close-on-esc no-close-on-backdrop hide-header-close id="modal-type-dpc" ref="modal-type-dpc" title="Choisissez un type de DPC">
      <b-form-group label="Quel type de DPC voulez-vous faire ?">
        <b-form-radio v-if="this.dossier.canal.libelle_technique === 'cev'" v-model="typeDpc" name="radio-type-dpc" value="cev">CeV</b-form-radio>
        <b-form-radio v-model="typeDpc" name="radio-type-dpc" value="courrier">Courrier</b-form-radio>
        <b-form-radio v-model="typeDpc" name="radio-type-dpc" value="mail">Mail</b-form-radio>
      </b-form-group>
      <span class="field-error d-block mr-1 ">{{ errors.typeDpc }}</span>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" @click="saveDpcType()" class="btn btn-primary"><i class="fa fa-save"></i> Enregistrer</button>
        </div>
      </template>
    </b-modal>

    <b-modal centered no-close-on-esc no-close-on-backdrop hide-header-close title="Chargement du courrier envoyé au client" id="modal-chargement-courrier" ref="modal-chargement-courrier">
      <b-form>
        <div>
          <b-form-group v-if="!isEmpty(dossier.type) && dossier.type.groupe.toLowerCase() == 'dc'"
            label='Date du courrier'>
            <b-form-input type="date" id="date_relance" v-model="dpcCourrierDateRelance" :class="{hasError: errors.dpcCourrierDateRelance !== ''}">
            </b-form-input>
            <span class="field-error">{{ errors.dpcCourrierDateRelance }}</span>
          </b-form-group>
          <b-form-group
            label='Courrier envoyé au client'
            label-for='nom_fichier'>
            <b-form-file placeholder="Veuillez choisir ou déposer le fichier ici"
                         class="file-input"
                         drop-placeholder="Déposer le fichier ici..."
                         browse-text="Parcourir"
                         :state="errors.attachment !== '' ? false : null"
                         @change="addFile($event)"
                         @input="clearErrors()">
            </b-form-file>
            <span class="field-error">{{ errors.attachment }}</span>
          </b-form-group>
        </div>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right ml-2"
            @click="saveFile()">
            Enregistrer
          </b-button>
          <b-button
            variant="danger"
            class="float-right"
            @click="closeModal('modal-chargement-courrier')">
            Annuler
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop hide-header-close :title="this.isRelance === false ? 'Envoi de DPC' : 'Envoi de relance'" id="modal-mail-dpc" ref="modal-mail-dpc">
      <b-form>
        <b-row v-if="this.incidentSelected && this.incidentSelected.dpc && this.incidentSelected.dpc.type_dpc !== 'cev'">
          <b-col sm="1">
            <label for="mailTo">A :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="mailTo" type="text" v-model="mailTo" autocomplete="off" :class="{hasError: changeMailAddress || errors.mailTo !== ''}"></b-form-input>
            <span class="field-error">{{ errors.mailTo }}</span>
          </b-col>
          <b-col sm="2" v-if="changeMailAddress" style="padding-top:5px;margin-left:-18px">
            <span style="color:#ff1744;"><b>Attention</b><i class="fa fa-question-circle ml-2 text-primary" id="tooltip-mail-to"></i></span>
          </b-col>
          <b-col sm="2" v-if="changeMailAddress">
            <b-tooltip target="tooltip-mail-to" triggers="hover" placement="right">Indiquez l'adresse mail du client.</b-tooltip>
          </b-col>
        </b-row>
        <b-row class="mt-1" v-if="this.incidentSelected && this.incidentSelected.dpc && this.incidentSelected.dpc.type_dpc !== 'cev'">
          <b-col sm="1">
            <label for="mailCc">Cc :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="mailCc" type="text" v-model="mailCc"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-1" v-if="this.incidentSelected && this.incidentSelected.dpc && this.incidentSelected.dpc.type_dpc !== 'cev'">
          <b-col sm="1">
            <label for="mailSubject">Objet :</label>
          </b-col>
          <b-col sm="6">
            <b-form-input id="mailSubject" type="text" v-model="mailSubject" disabled></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm=8>
            <ul class="no-padding no-decoration">
              <li v-for="(pj, key) in dpcAttachmentsUploaded" :key="key">
                <a href="#" @click.prevent="downloadDpcPj(pj)"><img class="mr-2 icon-size-16" :src="getIconSrcPj(pj)"> {{ pj.name }}</a> {{getReadableFileSize(pj.size)}} <i v-if="canDeleteDpcPj()" @click="deleteDpcPj(pj)" class="fa fa-trash text-danger clickable"></i>
              </li>
            </ul>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col sm="6" v-if="this.incidentSelected && this.incidentSelected.dpc && this.incidentSelected.dpc.type_dpc !== 'cev'">
            <b-row align-h="start" class="mt-2">
              <b-col sm="2">
                <label for="files">Fichier(s) :</label>
              </b-col>
              <b-col sm="7">
                <b-form-file placeholder="Veuillez choisir ou déposer le(s) fichier(s) ici"
                  multiple
                  class="file-input"
                  drop-placeholder="Déposer le(s) fichier(s) ici..."
                  browse-text="Parcourir"
                  :file-name-formatter="formatNames"
                  @change="addFileToDpc($event)"
                >
                </b-form-file>
              </b-col>
              <b-col sm="3">
              <b-button v-if="this.isRelance"
                    variant="success"
                    class="float-right"
                    @click="$bvModal.show('modal-relance-ajout-pj')">
                    Sélection PJ
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="6">
            <b-row align-h="end" class="mt-2" v-if="this.incidentSelected && this.incidentSelected.dpc && this.incidentSelected.dpc.type_dpc !== 'cev'">
              <b-col sm="2">
                <label for="model_mail">Modele :</label>
              </b-col>
              <b-col sm="8">
                <b-form-select id="model_mail" v-model="selecteddpcMailModele" :options="dpcMailModeleOptions" @change="manageModelDpc()" :class="{hasError: errors.selecteddpcMailModele !== ''}">
                </b-form-select>
                <span class="field-error">{{ errors.selecteddpcMailModele }}</span>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col sm="2">
                <label for="model_cev">Modele :</label>
              </b-col>
              <b-col sm="8">
                <b-form-select id="model_cev" v-model="selecteddpcCevModele" :options="dpcCevModeleOptions" @change="manageModelDpc()">
                </b-form-select>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col sm=8>
            <span v-for="(pjId, key) in pjRelanceDeces" :key="key">
              <a href="#" @click.prevent="downloadMailPj(pjId)">
                <img class="mr-2 icon-size-16" :src="getIconSrcPj(pjId)"> {{ getPjName(pjId) }}
              </a> /
            </span>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <ckeditor v-if="this.incidentSelected && this.incidentSelected.dpc && this.incidentSelected.dpc.type_dpc !== 'cev'" :editor="editor" v-model="mailBody" :config="editorConfig"></ckeditor>
          <div v-else v-html="mailBody" class="p-3 border w-100 mb-2"></div>
        </b-row>
        <div>{{ dpcCommentaire ? dpcCommentaire : '' }}</div>
        <div v-if="incidentSelected && incidentSelected.dpc && incidentSelected.dpc.type_dpc === 'cev'">Pièces demandées :<br>
          <ul id="documents_needed">
            <li v-for="askedDocument in documentsNeeded" :key="askedDocument.libelle_court">
              <!-- <span v-if="!isEmpty(askedDocument.pivot) && !isEmpty(askedDocument.pivot.commentaire)" v-html="getLibelleDocumentDemande(askedDocument)"></span> -->
              <span v-if="(askedDocument.libelle_technique === 'decomptes_ss' && !isEmpty(commentaireDocDecompteSS)) || (askedDocument.libelle_technique === 'bulletins_salaire' && !isEmpty(commentaireDocBS))" v-html="getLibelleDocumentDemande(askedDocument, 'creation')"></span>
              <span v-else><b>{{ askedDocument.libelle_court }}</b></span>
            </li>
          </ul>
        </div>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <span v-if="dpcMailToContinue.wait_for_validation && (isResponsable() || canValidateDpc())">
            <b-button
              variant="danger"
              class="float-right ml-2"
              @click="reject(incidentSelected)">
              <i class="fa fa-times"></i>
              Refuser
            </b-button>
            <b-button
              variant="primary"
              class="float-right ml-2"
              @click="saveDpcMail('valide')">
              <i class="fa fa-check"></i>
              Valider et retour au gestionnaire
            </b-button>
            <b-button
              variant="primary"
              class="float-right ml-2"
              @click="saveDpcMail('valideAndSend')">
              <i class="fa fa-paper-plane"></i>
              Envoyer directement
            </b-button>
          </span>
          <span v-else>
            <b-button
              variant="primary"
              class="float-right ml-2"
              @click="saveDpcMail('send')">
              <i class="fa fa-paper-plane"></i>
              Envoyer
            </b-button>
            <b-button
              variant="warning"
              class="float-right ml-2"
              @click="saveDpcMail('save')">
              <i class="fa fa-save"></i>
              Brouillon
            </b-button>
          </span>
          <b-button
            variant="secondary"
            class="float-right"
            @click="closeDpcMailModal()">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="lg" centered no-close-on-esc no-close-on-backdrop hide-header-close :title="this.isRelanceAnnuelle === false ? 'Envoi de relance courrier' : 'Envoi de relance annuelle'" id="modal-relance-courrier-dpc" ref="modal-relance-courrier-dpc">
      <b-form>
        <b-row align-h="end" class="mt-2" v-if="this.incidentSelected && this.incidentSelected.dpc && this.incidentSelected.dpc.type_dpc !== 'cev'">
          <b-col>
            <label for="model_mail">Type Relance :</label>
          </b-col>
          <b-col>
            <b-form-select id="model_mail" v-model="selecteddpcCourrierModele" :options="dpcCourrierModeleOptions" :class="{hasError: errors.selecteddpcCourrierModele !== ''}">
            </b-form-select>
            <span class="field-error">{{ errors.selecteddpcCourrierModele }}</span>
          </b-col>
        </b-row>
        <b-row align-h="end" class="mt-2" v-if="this.incidentSelected && this.incidentSelected.dpc && this.incidentSelected.dpc.type_dpc !== 'cev'">
          <b-col>
            <label for="model_mail">Date du Courrier :</label>
          </b-col>
          <b-col>
            <b-form-input type="date" id="dpcCourrierDateRelance" v-model="dpcCourrierDateRelance" :class="{hasError: errors.dpcCourrierDateRelance !== ''}">
              </b-form-input>
              <span class="field-error">{{ errors.dpcCourrierDateRelance }}</span>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <label for="model_mail">Courrier envoyé au client :</label>
          </b-col>
          <b-col>
            <b-form-file placeholder="Veuillez choisir ou déposer le fichier ici"
                         class="file-input"
                         drop-placeholder="Déposer le fichier ici..."
                         browse-text="Parcourir"
                         :state="errors.attachment !== '' ? false : null"
                         @change="addFile($event)"
                         @input="clearErrors()">
            </b-form-file>
            <span class="field-error">{{ errors.attachment }}</span>
          </b-col>
        </b-row>
        <hr>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right ml-2"
            @click="saveRelanceCourrier()">
            Enregistrer
          </b-button>
          <b-button
            variant="danger"
            class="float-right"
            @click="closeRelanceCourrier()">
            Annuler
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop hide-header-close id="modal-document-dpc" ref="modal-document-dpc" title="Renseignez les informations nécessaires à la DPC">
      <label>Contexte : </label>
      <b-form-textarea id="dpcCommentaire"
        label="Contexte"
        type="text"
        rows="2"
        max-rows="9"
        v-model="dpcCommentaire">
      </b-form-textarea><br>
      <b-row v-for="doc in dpcDocuments" :key="doc.id">
        <b-col sm="12">
          <span class="field-error">{{ errors.documentsNeeded }}</span>
          <b-form-checkbox
            :id="`checkbox-${doc.id}`"
            v-model="documentsNeeded"
            :name="`checkbox-${doc.id}`"
            :value="doc"
            :state="errors.documentsNeeded !== '' ? false : null"
            @input="clearSelectedError('documentsNeeded')"
          >
            {{ doc.libelle_court }}
            <!-- <b-form-textarea v-if="doc.libelle_technique === 'decomptes_ss' || doc.libelle_technique === 'bulletins_salaire'"
              :id="`commentaireDoc-${doc.id}`"
              :name="`commentaireDoc-${doc.id}`"
              type="text"
              rows="2"
              max-rows="9"
              v-model="commentaireDoc"
            ></b-form-textarea> -->
          </b-form-checkbox>

          <b-form-textarea v-if="doc.libelle_technique === 'decomptes_ss'"
            id="commentaireDecompteSS"
            type="text"
            rows="2"
            max-rows="9"
            v-model="commentaireDocDecompteSS">
          </b-form-textarea>

          <b-form-textarea v-if="doc.libelle_technique === 'bulletins_salaire'"
            id="commentaireBS"
            type="text"
            rows="2"
            max-rows="9"
            v-model="commentaireDocBS">
          </b-form-textarea>
        </b-col>
      </b-row>
      <span class="field-error d-block mr-1 ">{{ errors.documentsNeeded }}</span>
      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right ml-2" @click="cancelCheck()"><i class="fa fa-cancel"></i>
          Annuler
        </b-button>
        <b-button variant="primary" class="float-right ml-2" @click="checkDocuments()">
          <i class="fa fa-save"></i>
          Enregistrer
        </b-button>
        <!-- <div class="w-100 text-right">
          <button type="button" @click="cancelCheck()" class="btn btn-primary"><i class="fa fa-save"></i> Annuler</button>
        </div>
        <div class="w-100 text-right">
          <button type="button" @click="checkDocuments()" class="btn btn-primary"><i class="fa fa-save"></i> Enregistrer</button>
        </div> -->
      </template>
    </b-modal>


    <!-- DPC RELANCE DECES  : Choix des pièces jointes à envoyer avec une relance -->
    <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop id="modal-relance-ajout-pj" ref="modal-relance-ajout-pj" title="Choisissez les pièces jointes à envoyer" ok-only ok-title="Fermer">
      <label><strong>Pièces jointes : </strong></label>
      <b-row>
        <b-col sm="6">
          <label>Externe</label>
          <b-row v-for="pj in this.piecesJointesExterne" :key="pj.id">
            <b-col sm="12">
              <b-form-checkbox
                :id="`checkbox-dpc-${pj.id}`"
                :disabled="pj.size > maxPjMutex"
                v-model="pjRelanceDeces"
                :name="`checkbox-dpc-${pj.id}`"
                :value="pj.id"
                :state="null"
                style="margin-right:10px;"
              >
              <img class="mr-2 icon-size-16" :src="getIconSrcPj(pj)">
              <a href="#" @click.prevent="downloadMailPj(pj.id)">
                <span v-if="pj.types_pj && pj.types_pj.length >= 1"> {{ reducedFileName(pj.name) }}</span>
                <span v-else :title="pj.name"> {{ reducedFileName(pj.name) }}</span>
              </a>
              <i v-if="pj.size > maxPjMutex" class="ml-2 fa fa-question-circle text-danger" v-b-tooltip.hover title="Ce document est trop volumineux, il ne peut être envoyé par mail"></i>
            </b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="6">
          <label>Interne</label>
          <b-row v-for="pj in this.piecesJointesInterne" :key="pj.id">
            <b-col sm="12">
              <b-form-checkbox
                :id="`checkbox-dpc-${pj.id}`"
                :disabled="pj.size > maxPjMutex"
                v-model="pjRelanceDeces"
                :name="`checkbox-dpc-${pj.id}`"
                :value="pj.id"
                :state="null"
              >
              <img class="mr-2 icon-size-16" :src="getIconSrcPj(pj)">
              <a href="#" @click.prevent="downloadMailPj(pj.id)">
                <span v-if="pj.types_pj && pj.types_pj.length >= 1"> {{ reducedFileName(pj.name) }}</span>
                <span v-else :title="pj.name"> {{ reducedFileName(pj.name) }}</span>
              </a>
              <i v-if="pj.size > maxPjMutex" class="ml-2 fa fa-question-circle text-danger" v-b-tooltip.hover title="Ce document est trop volumineux, il ne peut être envoyé par mail"></i>
              </b-form-checkbox>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <template v-slot:modal-footer>
        <!-- <b-button variant="secondary" class="float-right ml-2" @click="SaveRelanceAjoutPj()"><i class="fa fa-times"></i>
          Fermer
        </b-button> -->
        <b-button variant="danger" class="float-right ml-2" @click="cancelRelanceAjoutPj()"><i class="fa fa-ban"></i>
          Supprimer les pj sélectionnées
        </b-button>
        <b-button variant="primary" class="float-right ml-2" @click="SaveRelanceAjoutPj()">
          <i class="fa fa-check"></i>
          Valider
        </b-button>
      </template>
    </b-modal>

    <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop
      title="Liste des courriers envoyés au client"
      id="modal-mail-sent-dpc"
      ref="modal-mail-sent-dpc"
      @close="closeViewSentMailModal">
      <b-card no-body v-for="mail in alreadySentMails" :key="mail.id">
        <div class="card-smallHeader card-header-action">
          <span>{{ mail.subject }}</span>
        </div>
        <b-card-text class="pl-2 pr-1 pt-1 pb-1">
          Envoyé à : {{ mail.to }}<br>
          Envoyé le : {{ mail.sent_at }}<br>
          Sujet : {{ mail.subject }}<br>
          <ul class="no-padding no-decoration">
            <li v-for="(pj, key) in mail.pieces_jointes" :key="key">
              <a href="#" @click.prevent="downloadDpcPj(pj)"><img class="mr-2 icon-size-16" :src="getIconSrcPj(pj)" alt="icon pj"> {{ pj.name }}</a> {{getReadableFileSize(pj.size)}}
            </li>
            <li v-for="(pj, key) in mail.pieces_jointes_liees" :key="key">
              <a href="#" @click.prevent="downloadDpcPj(pj)"><img class="mr-2 icon-size-16" :src="getIconSrcPj(pj)" alt="icon pj"> {{ pj.name }}</a> {{getReadableFileSize(pj.size)}}
            </li>
          </ul>
          Message : <br>
          <div style="border: 1px solid #DFDFDF; padding: 1em;" v-html="mail.body"></div>
          <span>{{ dpcCommentaire }}</span>
          <div v-if="incidentSelected && incidentSelected.dpc && incidentSelected.dpc.type_dpc === 'cev'">Pièces demandées :<br>
            <ul id="documents_needed">
              <li v-for="askedDocument in mail.dpc_type_documents" :key="askedDocument.libelle_court">
                <span v-if="!isEmpty(askedDocument.pivot) && !isEmpty(askedDocument.pivot.commentaire)" v-html="getLibelleDocumentDemande(askedDocument)"></span>
                <span v-else><b>{{ askedDocument.libelle_court }}</b></span>
              </li>
            </ul>
          </div>
        </b-card-text>
      </b-card>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="danger"
            class="float-right"
            @click="closeViewSentMailModal()">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop hide-header-close :title="titreModalDbco" id="modal-mail-dbco" ref="modal-mail-dbco">
      <b-form>
        <b-row>
          <b-col sm="1">
            <label for="mailDbcoTo">A :</label>
          </b-col>
          <b-col sm="12" md="8">
            <b-form-input id="mailDbcoTo" type="text" v-model="mailDbcoTo"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="mailDbcoCc">Cc :</label>
          </b-col>
          <b-col sm="12" md="8">
            <b-form-input id="mailDbcoCc" type="text" v-model="mailDbcoCc" placeholder="Liste d'adresses mail séparées par des ;"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="mailDbcoSubject">Objet :</label>
          </b-col>
          <b-col sm="12" md="8">
            <b-form-input id="mailDbcoSubject" type="text" v-model="mailDbcoSubject" disabled></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col sm="12">
            <b-row align-h="start" class="mt-2">
              <b-col sm="1">
                <label for="files">Fichier(s) :</label>
              </b-col>
              <b-col sm="8">
                <b-form-file placeholder="Veuillez choisir ou déposer le(s) fichier(s) ici"
                  multiple
                  class="file-input"
                  drop-placeholder="Déposer le(s) fichier(s) ici..."
                  browse-text="Parcourir"
                  :file-name-formatter="formatNames"
                  @change="addFileToDpc($event,'dbco')"
                >
                </b-form-file>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="1">
          </b-col>
          <b-col sm="10">
            <ul class="no-padding no-decoration mb-0">
              <li v-for="(pj, key) in mailDbcoPiecesJointes" :key="key">
                <a href="#" @click.prevent="downloadDpcPj(pj)"><img class="mr-2 icon-size-16" :src="getIconSrcPj(pj)"> {{ pj.name }}</a> {{getReadableFileSize(pj.size)}} <i v-if="canDeleteDpcPj('dbco')" @click="deleteDpcPj(pj,'dbco')" class="fa fa-trash text-danger clickable"></i>
              </li>
            </ul>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="12">
            <h6><i>Partie générée automatiquement en fonction des données du bloc "Données DBCO"</i></h6>
            <div v-html="mailDbcoAuto"></div>
          </b-col>
        </b-row>
        <b-row v-if="showPrecisionAutre">
          <b-col sm="12" class="mt-3">
            <h6><i>Précision concernant le motif "Autre"</i></h6>
            <ckeditor v-if="canManageDbco('responsable') || canManageDbco('gestionnaire')" :editor="editor" v-model="mailDbcoCustom" :config="editorConfig"></ckeditor>
            <div v-else>{{ mailDbcoCustom }}</div>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col sm="12">
            <h6><i>Signature apposée au mail</i></h6>
            <div v-html="mailDbcoSignature"></div>
          </b-col>
        </b-row>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <span v-if="isTraitementByLibelle('validation_dbco')">
            <b-button
              variant="primary"
              class="float-right ml-2"
              @click="initiateSaveMailDbco('valideAndSend')">
              <i class="fa fa-paper-plane"></i>
              Valider et Envoyer
            </b-button>
            <b-button
              variant="warning"
              class="float-right ml-2"
              @click="initiateSaveMailDbco('save')">
              <i class="fa fa-save"></i>
              Brouillon
            </b-button>
          </span>
          <span v-if="isTraitementByLibelle('gestion_dbco')">
            <b-button
              variant="primary"
              class="float-right ml-2"
              @click="initiateSaveMailDbco('send')">
              <i class="fa fa-paper-plane"></i>
              Envoyer
            </b-button>
            <b-button
              variant="warning"
              class="float-right ml-2"
              @click="initiateSaveMailDbco('save')">
              <i class="fa fa-save"></i>
              Brouillon
            </b-button>
          </span>
          <b-button
            variant="secondary"
            class="float-right"
            @click="closeMailDbcoModal()">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop hide-header-close :title="titreModalDbco" id="modal-print-dbco" ref="modal-print-dbco">
      <div id="block-print">
        <div class="print_dbco_adresse">
          <b-row>
            <b-col sm="12">{{ dossier.prenom.substring(0,1).toUpperCase() + dossier.prenom.substring(1) }} {{ !isEmpty(dossier.nom) ? dossier.nom.toUpperCase() : dossier.nom_naissance.toUpperCase() }}</b-col>
          </b-row>
          <b-row>
            <b-col sm="12">{{ dossier.adresse1.toUpperCase() }}</b-col>
          </b-row>
          <b-row>
            <b-col sm="12">&nbsp;</b-col>
          </b-row>
          <b-row>
            <b-col sm="12">{{ dossier.adresse2.toUpperCase() }}</b-col>
          </b-row>
          <b-row>
            <b-col sm="12">&nbsp;</b-col>
          </b-row>
          <b-row>
            <b-col sm="12">&nbsp;</b-col>
          </b-row>
          <b-row>
            <b-col sm="12">Paris, le {{ getDateCourrier() }}</b-col>
          </b-row>
        </div>
        <div class="print_dbco_text">
          <div v-html="mailDbcoAuto"></div>
          <div v-if="mailDbcoCustom && mailDbcoCustom !== 'null' && mailDbcoCustom !== 'NULL'" style="with: 100%;border: 1px solid #EFEFEF; padding: 5px 15px;margin-bottom: 10px;">
            <b>*Précision</b> :
            <div v-html="mailDbcoCustom"></div>
          </div>
          <br>
          <div v-html="mailDbcoSignature"></div>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="warning"
            class="float-right"
            @click="print()">
            Imprimer
          </b-button>
          <b-button
            variant="danger"
            class="float-right"
            @click="$bvModal.hide('modal-print-dbco')">
            Annuler
          </b-button>
        </div>
      </template>
    </b-modal> -->

    <b-modal size="xl" centered title="Lecture mail de Conformité / Non conformité" id="modal-mail-dbco-readOnly" ref="modal-mail-dbco-readOnly">
      <b-form>
        <b-row>
          <b-col sm="1">
            <label for="mailDbcoTo">A :</label>
          </b-col>
          <b-col sm="12" md="8">
            <div id="mailDbcoTo">{{mailDbcoTo}}</div>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="mailDbcoCc">Cc :</label>
          </b-col>
          <b-col sm="12" md="8">
            <div id="mailDbcoCc">{{mailDbcoCc}}</div>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="mailDbcoSubject">Objet :</label>
          </b-col>
          <b-col sm="12" md="8">
            <div id="mailDbcoSubject">{{mailDbcoSubject}}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="1">
          </b-col>
          <b-col sm="10">
            <ul class="no-padding no-decoration mb-0">
              <li v-for="(pj, key) in mailDbcoPiecesJointes" :key="key">
                <a href="#" @click.prevent="downloadDpcPj(pj)"><img class="mr-2 icon-size-16" :src="getIconSrcPj(pj)" alt="icon pj"> {{ pj.name }}</a> {{getReadableFileSize(pj.size)}}
              </li>
            </ul>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="12">
            <div v-html="mailDbcoAuto"></div>
            <div v-if="mailDbcoCustom && mailDbcoCustom !== 'null' && mailDbcoCustom !== 'NULL'" style="with: 100%;border: 1px solid #EFEFEF; padding: 5px 15px;margin-bottom: 10px;">
              <b>*Précision</b> :
              <div v-html="mailDbcoCustom"></div>
            </div>
            <br>
            <div v-html="mailDbcoSignature"></div>
          </b-col>
        </b-row>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="danger"
            class="float-right"
            @click="$bvModal.hide('modal-mail-dbco-readOnly')">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal centered title="Informations Qualité" id="modal-info-qualite" ref="modal-info-qualite">
      <b-form>
        <b-row v-if="motifAnomalieControle">
          <b-col md="4">
            <label for="motifAnomalieControle"><b>Motif Anomalie :</b></label>
          </b-col>
          <b-col md="8">
            <div id="motifAnomalieControle">{{motifAnomalieControle}}</div>
          </b-col>
        </b-row>
        <b-row v-if="resultatControle" class="mt-1">
          <b-col md="4">
            <label for="resultatControle"><b>Résultat Contrôle :</b></label>
          </b-col>
          <b-col md="8">
            <div id="resultatControle">{{resultatControle}}</div>
          </b-col>
        </b-row>
        <b-row v-if="commentaireControle" class="mt-1">
          <b-col md="4">
            <label for="commentaireControle"><b>Commentaire :</b></label>
          </b-col>
          <b-col md="8">
            <div id="commentaireControle">{{commentaireControle}}</div>
          </b-col>
        </b-row>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="danger"
            class="float-right"
            @click="$bvModal.hide('modal-info-qualite')">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" centered title="BLOCAGE COTISATION" id="modal-nic" ref="modal-nic">
      <h5>Information structure</h5>
      <div class="border p-2 mb-3">
        <b-row class="mb-1">
          <b-col sm="6" md="2" lg="1" class="flex-center">
            <label for="nic"><b>NIC :</b></label>
          </b-col>
          <b-col sm="12" md="3" lg="2">
            <b-form-input id="nic" v-model="nic" placeholder="NIC" :class="{hasError: errors.nic !== ''}"></b-form-input>
            <span class="field-error">{{ errors.nic }}</span>
          </b-col>
        </b-row>
        </div>
        <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right ml-2"
            @click="save(selectedIncident)">
            <i class="fa fa-paper-plane"></i> Valider
          </b-button>
          <b-button
            variant="danger"
            class="float-right ml-2"
            @click="closeModalNic()">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" centered title="FICHE D'AFFILIATION D'URGENCE" id="modal-affiliation" ref="modal-affiliation">
      <h5>Information structure</h5>
      <div class="border p-2 mb-3">
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="2"  class="flex-center">
            <label for="sirenAffiliation"><b>SIREN :</b></label>
          </b-col>
          <b-col sm="12" md="4">
            <b-form-input id="sirenAffiliation" v-model="$parent.$parent.$parent.siren" placeholder="SIREN" :class="{hasError: errors.siren !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.siren }}</span>
          </b-col>
          <b-col sm="6" md="2" lg="1" class="flex-center">
            <label for="nic"><b>NIC :</b></label>
          </b-col>
          <b-col sm="12" md="3" lg="2">
            <b-form-input id="nic" v-model="nic" placeholder="NIC" :class="{hasError: errors.nic !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.nic }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="2" class="flex-center">
            <label for="familleProduitId"><b>Produit :</b></label>
          </b-col>
          <b-col sm="12" md="9" lg="7">
            <b-form-select id="familleProduitId"
                           v-model="$parent.$parent.$parent.selectedFamilleProduit"
                           :options="$parent.$parent.$parent.allFamillesProduits"
                           :class="{hasError: errors.familleProduit !== ''}"
                           :disabled="selectedIncident.visu === 'readOnly'">
            </b-form-select>
            <span class="field-error">{{ errors.familleProduit }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="2" class="flex-center">
            <label for="raisonSociale"><b>Dénomination :</b></label>
          </b-col>
          <b-col sm="12" md="9" lg="7">
            <b-form-input id="raisonSociale" v-model="raisonSociale" placeholder="Raison sociale" :class="{hasError: errors.raisonSociale !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.raisonSociale }}</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <p>
              <i><b>Attention</b> en cas de regroupement préciser le SIRET souscripteur prestation (SDC demandée pour avoir cette info importante)<br>
              Nécessaire en cas de multi structures<br></i>
            </p>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="2" class="flex-center">
            <label for="sirenSouscripteur"><b>SIREN Sous. :</b></label>
          </b-col>
          <b-col sm="12" md="4">
            <b-form-input id="sirenSouscripteur" v-model="sirenSouscripteur" placeholder="SIREN souscripteur" :class="{hasError: errors.sirenSouscripteur !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.sirenSouscripteur }}</span>
          </b-col>
          <b-col sm="6" md="3" lg="2" class="flex-center">
            <label for="nicSouscripteur"><b>Nic Sous. :</b></label>
          </b-col>
          <b-col sm="12" md="2" lg="2">
            <b-form-input id="nicSouscripteur" v-model="nicSouscripteur" placeholder="NIC sous." :class="{hasError: errors.nicSouscripteur !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.nicSouscripteur }}</span>
          </b-col>
        </b-row>
      </div>
      <h5>Motifs d'affiliation d'urgence</h5>
      <div class="p-2 mb-3">
        <div><b>- Le salarié est inexistant :</b></div>
        <b-row v-for="motif of motifsAffiliation.creation" :key="motif.id">
          <b-col sm="12">
            <b-form-checkbox
              :id="'checkbox-motif'+motif.id"
              v-model="selectedMotifs"
              :name="'checkbox-motif'+motif.id"
              :value="motif"
              :key="motif.id"
              :class="[errors.selectedMotifs !== '' ? 'hasErrorLibelle' : '', 'motif_'+motif.type]"
              :disabled="checkDisableCheckboxAffiliation(motif)"
            >
              {{ motif.libelle }}
            </b-form-checkbox>
          </b-col>
        </b-row>
        <div class="mt-2"><b>- Information salarié à modifier :</b></div>
        <b-row v-for="motif of motifsAffiliation.modification" :key="motif.id">
          <b-col sm="12">
            <b-form-checkbox
              :id="'checkbox-motif'+motif.id"
              v-model="selectedMotifs"
              :name="'checkbox-motif'+motif.id"
              :value="motif"
              :key="motif.id"
              :class="[errors.selectedMotifs !== '' ? 'hasErrorLibelle' : '', 'motif_'+motif.type]"
              :disabled="checkDisableCheckboxAffiliation(motif)"
            >
              {{ motif.libelle_technique === 'portabilite' ? motif.libelle+'**' : motif.libelle }}
            </b-form-checkbox>
          </b-col>
          <!-- <b-col sm="6" md="5" lg="4" v-else>
            <b-form-checkbox
              :id="'checkbox-motif'+motif.id"
              v-model="selectedMotifs"
              :name="'checkbox-motif'+motif.id"
              :value="motif"
              :key="motif.id"
              :class="[errors.selectedMotifs !== '' ? 'hasErrorLibelle' : '', 'motif_'+motif.type, 'pt-2']"
              :disabled="checkDisableCheckboxAffiliation(motif)"
            >
              {{ motif.libelle }}
            </b-form-checkbox>
          </b-col> -->
          <!-- <b-col sm="6" md="7"  v-if="motif.libelle_technique === 'contrat_option_facultatif'">
            <b-form-input v-model="commentaireMotif" :class="{hasError: errors.commentaireMotif !== ''}" placeholder="Commentaires (par ex: statut et options pour la CCN ECLAT, la garantie...)" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.commentaireMotif }}</span>
          </b-col> -->
        </b-row>
        <span class="field-error">{{ errors.selectedMotifs }}</span>
      </div>
      <h5>Information assuré :</h5>
      <div class="border p-2 mb-3">
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="2"  class="flex-center">
            <label for="nir"><b>NIR avec la clé :</b></label>
          </b-col>
          <b-col sm="12" md="9" lg="7">
            <b-form-input id="nir" v-model="nirAffiliation" placeholder="Saisir le NIR de l'assuré" :class="{hasError: errors.nir !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.nir }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="2" class="flex-center">
            <label for="nom"><b>Nom :</b></label>
          </b-col>
          <b-col sm="12" md="9" lg="7">
            <b-form-input id="nom" v-model="$parent.$parent.$parent.nom" placeholder="Saisir le nom de l'assuré" :class="{hasError: errors.nom !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.nom }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="2" class="flex-center">
            <label for="prenom"><b>Prénom :</b></label>
          </b-col>
          <b-col sm="12" md="9" lg="7">
            <b-form-input id="prenom" v-model="$parent.$parent.$parent.prenom" placeholder="Saisir le prénom de l'assuré" :class="{hasError: errors.prenom !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.prenom }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="2" class="flex-center">
            <label for="dateNaissance"><b>Date de naissance</b> <i class="fa fa-question-circle text-primary ml-1" id="tooltip-info-date-naissance"></i> :</label>
            <b-tooltip target="tooltip-info-date-naissance" placement="topright" triggers="hover">Indiquez la date réelle de naissance et non une aproximation</b-tooltip>
          </b-col>
          <b-col sm="12" md="9" lg="7">
            <b-form-input type="date" id="dateNaissance" v-model="$parent.$parent.$parent.date_naissance" :class="{hasError: errors.dateNaissance !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.dateNaissance }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="2" class="flex-center">
            <label for="dateEmbauche"><b>Date d'embauche :</b></label>
          </b-col>
          <b-col sm="12" md="9" lg="7">
            <b-form-input type="date" id="dateEmbauche" v-model="dateEmbauche" :class="{hasError: errors.dateEmbauche !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.dateEmbauche }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="2" class="flex-center">
            <label for="dateEvenement"><b>Date d'événement :</b></label>
          </b-col>
          <b-col sm="12" md="9" lg="7">
            <b-form-input type="date" id="dateEvenement" v-model="dateEvenement" :class="{hasError: errors.dateEvenement !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.dateEvenement }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="2" class="flex-center">
            <label for="categorie"><b>Catégorie :</b></label>
          </b-col>
          <b-col sm="12" md="9" lg="7">
            <b-form-radio-group
              id="radio-group-2"
              v-model="categorie"
              name="radio-categorie"
              :disabled="selectedIncident.visu === 'readOnly'"
            >
              <b-form-radio value="nc">NC</b-form-radio>
              <b-form-radio value="c">C</b-form-radio>
              <b-form-radio value="th">TH</b-form-radio>
            </b-form-radio-group>
            <span class="field-error">{{ errors.categorie }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1" v-if="showOptionMensu()">
          <b-col sm="6" md="3" lg="2" class="flex-center">
            <label for="categorie">
              <b-form-checkbox
                id="checkbox-option-mensu"
                v-model="affiliationOptionMensu"
                name="checkbox-option-mensu"
                value="true"
                :disabled="selectedIncident.visu === 'readOnly'"
              >
                <b>Option mensu :</b>
              </b-form-checkbox>
            </label>
          </b-col>
          <b-col sm="12" md="9" lg="7">
            <b-form-radio-group
              id="radio-affiliationOptionMensuValue"
              v-model="affiliationOptionMensuValue"
              name="radio-affiliationOptionMensuValue"
              :disabled="selectedIncident.visu === 'readOnly'"
              :class="[errors.affiliationOptionMensu !== '' ? 'hasErrorLibelle' : '']"
            >
              <b-form-radio value="classique">Classique</b-form-radio>
              <b-form-radio value="intermittent">Intermittent</b-form-radio>
              <b-form-radio value="fonctionnaire">Fonctionnaire</b-form-radio>
            </b-form-radio-group>
            <span class="field-error">{{ errors.affiliationOptionMensu }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1" v-if="showApprenti()">
          <b-col sm="6" md="3" lg="2" class="flex-center">
            <label for="categorie">
              <b>Apprenti/contrat pro :</b>
            </label>
          </b-col>
          <b-col sm="12" md="9" lg="7">
            <b-form-radio-group
              id="radio-apprenti"
              v-model="affiliationApprenti"
              name="radio-affiliationApprenti"
              :disabled="selectedIncident.visu === 'readOnly'"
              :class="[errors.affiliationApprenti !== '' ? 'hasErrorLibelle' : '']"
            >
              <b-form-radio value="oui">Oui</b-form-radio>
              <b-form-radio value="non">Non</b-form-radio>
            </b-form-radio-group>
            <span class="field-error">{{ errors.affiliationApprenti }}</span>
          </b-col>
        </b-row>
      </div>
      <div v-if="showInfosPortabilite" class="border p-2 mb-3">
        <h5>En cas de portabilité**</h5>
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="3"  class="flex-center">
            <label for="dateDebutPortabilite"><b>Période de portabilité du :</b></label>
          </b-col>
          <b-col sm="12" md="2">
            <b-form-input type="date" id="dateDebutPortabilite" v-model="dateDebutPortabilite" :class="{hasError: errors.dateDebutPortabilite !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.dateDebutPortabilite }}</span>
          </b-col>
          <b-col sm="6" md="2" lg="1" class="flex-center">
            <label for="nic"><b>au :</b></label>
          </b-col>
          <b-col sm="12" md="2">
            <b-form-input type="date" id="dateFinPortabilite" v-model="dateFinPortabilite" :class="{hasError: errors.dateFinPortabilite !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.dateFinPortabilite }}</span>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col sm="6" md="3" lg="3" class="flex-center">
            <label for="familleProduitId"><b>Date de sortie :</b></label>
          </b-col>
          <b-col sm="12" md="3">
            <b-form-radio-group
              class="flex-center"
              id="radio-group-2"
              v-model="typeSortie"
              name="radio-type-sortie"
              :class="{hasError: errors.typeSortie !== ''}"
              :disabled="selectedIncident.visu === 'readOnly'"
            >
              <b-form-radio value="entreprise">entreprise</b-form-radio>
              <b-form-radio value="categorie">de la catégorie</b-form-radio>
            </b-form-radio-group>
            <span class="field-error">{{ errors.typeSortie }}</span>
          </b-col>
          <b-col sm="12" md="3">
            <b-form-input type="date" id="dateSortie" v-model="dateSortie" :class="{hasError: errors.dateSortie !== ''}" :disabled="selectedIncident.visu === 'readOnly'"></b-form-input>
            <span class="field-error">{{ errors.dateSortie }}</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm=12>
            <h6><u>Document nécessaire</u></h6>
            <p>Certificat de travail ou le document dédié à la portabilité sur cev (en cas de portabilité)</p>
          </b-col>
        </b-row>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            v-if="selectedIncident.visu !== 'readOnly'"
            variant="primary"
            class="float-right ml-2"
            @click="saveAffiliationForm('send')">
            <i class="fa fa-paper-plane"></i> Valider
          </b-button>
          <b-button
            v-if="selectedIncident.visu !== 'readOnly'"
            variant="warning"
            class="float-right ml-2"
            @click="saveAffiliationForm('save')">
            <i class="fa fa-save"></i> Brouillon
          </b-button>
          <b-button
            variant="danger"
            class="float-right ml-2"
            @click="$bvModal.hide('modal-affiliation')">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal centered id="modal-resultat-motifAno" ref="modal-resultat-motifAno" title="Renseigner le résultat et le motif de l'anomalie" :dossier="dossier">
      <label><b>Résultat</b></label>
      <b-form-select v-model="$parent.$parent.$parent.resultatIncident" :options="$parent.$parent.$parent.currentTreatment.libelle_technique==='ij_expertise_presta_niv2' ? $parent.$parent.$parent.appuiExpertOptions : $parent.$parent.$parent.resultatsOptions" :class="{hasError: $parent.$parent.$parent.errors.resultatIncident !== ''}">
      </b-form-select>
      <span class="field-error d-block mr-1">{{ $parent.$parent.$parent.errors.resultatIncident }}</span>
      <label>
        <b v-if="$parent.$parent.$parent.currentTreatment.libelle_technique==='ij_expertise_presta_niv2'">Motif de sollicitation</b>
        <b v-else>Anomalie principale</b>
      </label>
      <b-form-select v-model="$parent.$parent.$parent.motifAnomalie" :options="$parent.$parent.$parent.computedResultat" :class="{hasError: $parent.$parent.$parent.errors.motifAnomalie !== ''}"
                     :disabled="$parent.$parent.$parent.resultatIncident === $parent.$parent.$parent.resultatOKId || $parent.$parent.$parent.currentTreatment.libelle_technique === 'ij_expertise_presta_niv2'">
      </b-form-select>
      <span v-if="$parent.$parent.$parent.errors.motifAnomalie !== ''" class="field-error d-block mr-1">{{ $parent.$parent.$parent.errors.motifAnomalie }}</span>
      <label><b>Commentaire</b></label>
      <b-form-textarea
        id="commentaire"
        type="text"
        rows="3"
        max-rows="9"
        v-model="$parent.$parent.$parent.commentaireControle">
      </b-form-textarea>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="closeModalResultatAno()">Annuler</button>
          <button type="button" @click="validateDataResultat()" class="btn btn-warning"><i class="fa fa-save"></i>
            Enregistrer
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { getUser } from '@/utils/auth'
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
  import '@ckeditor/ckeditor5-build-classic/build/translations/fr'
  import { checkSIRET, isEmpty, nl2br, downloadFile, getIconSrc as getIconSrcMain, getReadableFileSize as getReadableFileSizeMain } from "@/utils/fileHelper";
  import { hasRule, espaceGestionRules as rules } from "@/utils/rulesHelper";
  import { getMainTreatmentBasedOnType, dossierHasAffectation, formatDateTime, cantEditFicheDC } from "@/utils/communHelper";
  import { isResponsable as isResponsableEquipe, getUserTraitementIds } from '@/utils/userHelper';
  import moment from 'moment';
  import {PJ_SIZE_LIMIT_MUTEX} from '@/utils/constants';

  export default {
    name: "Incidents",
    props: [
      'dossier',
      'traitements'
    ],
    data() {
      return {
        editor: ClassicEditor,
        editorConfig: {
            allowedContent: true,
            toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'link', 'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells', '|', 'indent', 'outdent', 'bulletedList', 'numberedList', 'blockQuote', '|', 'undo', 'redo' ],
            language: 'fr'
        },
        isEmpty,
        moment,
        dateCreation: '',
        selectedSousStatut: '',
        selectedStatut: '',
        sousStatut: '',
        traitementPP: '',
        criterePriorite: '',
        collaborateurCreateur: '',
        destinataire: '',
        collaborateurAffecte: '',
        statut: '',
        traitementPS: '',
        dateStatutPS: '',
        newElementAdded: false,
        fields: [
          {
            key: 'dateCreation',
            label: 'Date de\ncréation',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'sousStatut',
            label: 'Incident',
            thClass: 'pre-formatted align-middle',
            sortable: true
          },
          {
            key: 'traitementPP',
            label: 'Traitement PP',
            thClass: 'pre-formatted align-middle',
            tdClass: 'tooltip-cell'
          },
          {
            key: 'criterePriorite',
            label: 'Critère de priorité',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'collaborateurCreateur',
            label: 'Collaborateur\ncréateur demande',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'destinataire',
            label: 'Destinataire',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'collaborateurAffecte',
            label: 'Collaborateur\naffecté au trt sec.',
            thClass: 'pre-formatted'
          },
          {
            key: 'statut',
            label: 'Statut',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'traitementPS',
            label: 'Traitement\nsecondaire',
            thClass: 'pre-formatted align-middle',
            tdClass: 'tooltip-cell'
          },
          {
            key: 'dateStatutPS',
            label: 'Date statut\nPS',
            thClass: 'pre-formatted align-middle'
          },
          {
            key: 'Action',
            label: 'Action',
            thClass: 'pre-formatted align-middle'
          }
        ],
        items: [],
        statusOptions: [
          {value: 27, text: 'En attente'},
          // {value: 50, text: 'En attente - DPC à valider'},
          {value: 0, text: 'Reçu'},
        ],
        sousStatusEnAttenteOptions: [],
        currentTreatment: {},
        incidents: [],
        incidentSelected: null,
        newIncident: null,
        typeDpc: '',
        incidentId: '',
        dpcId: '',
        dpcMailId: '',
        alreadySentMails: [],
        dpcMailToContinue: {},
        periodeDateDebut: null,
        periodeDateFin: null,
        arretDate: null,
        documentsInMessage: '',
        documentsNeeded: [],
        dpcDocuments: [],
        dpcMailModeles: [],
        dpcMailModeleOptions: [],
        dpcCourrierModeleOptions: [],
        dpcCourrierDateRelance: '',
        selecteddpcMailModele: '',
        selecteddpcCourrierModele: '',
        dpcCevModeles: [],
        dpcCevModeleOptions: [],
        selecteddpcCevModele: '',
        mailTo: '',
        changeMailAddress: false,
        mailCc: '',
        mailSubject: '',
        mailBody: '',
        attachment: '',
        dpcAttachments: [],
        dpcAttachmentsUploaded: [],
        myData: {
          commentaire: '',
        },
        lastComment: {},
        allComments: [],
        displayAllComments: false,
        errors: { typeDpc: '', attachment: '', periodeDateDebut: '', periodeDateFin: '', arretDate: '', documentsNeeded: '', incident: '' },
        canSaveIncident: false,
        selectedIncident: {},
        typeUpload: '',
        mailDbcoAuto: '',
        mailDbcoCustom: '',
        mailDbcoTo: '',
        mailDbcoCc: '',
        mailDbcoSubject: '',
        mailDbcoSignature: '',
        mailDbcoPiecesJointes: [],
        titreModalDbco: 'Envoi mail de Conformité',
        motifAnomalieControle: null,
        resultatControle: null,
        commentaireControle: null,
        isEmpty,
        canValidateDbcoSansAr: false,
        canContinueDbco: false,
        dbcoIsConforme: 'true',
        showPrecisionAutre: false,
        dpcContexte: 'classique',
        motifsAffiliation: [],
        allMotifsAffiliation: [],
        selectedMotifs: [],
        nic: '',
        nirAffiliation: '',
        raisonSociale: '',
        sirenSouscripteur: '',
        nicSouscripteur: '',
        dateEmbauche: '',
        dateEvenement: '',
        categorie: '',
        dateDebutPortabilite: '',
        dateFinPortabilite: '',
        dateSortie: '',
        typeSortie: '',
        showInfosPortabilite: false,
        commentaireMotif: '',
        affiliationOptionMensu: '',
        affiliationOptionMensuValue: '',
        affiliationApprenti: '',
        statusDpc: {},
        statusDpcAffiliation: {},
        canSendArDbcoAgain: false,
        commentaireDocDecompteSS : '',
        commentaireDocBS : '',
        commentaireDoc: '',
        initiateBlocageCotisation : false,
        dpcCommentaire: '',
        isRelanceAnnuelle: false,
        isRelance: true,
        pjRelanceDeces: [],
        maxPjMutex: PJ_SIZE_LIMIT_MUTEX,
        pieces_jointes: [],
        errors: {
          incident: '',
          siren: '',
          nic: '',
          familleProduit: '',
          raisonSociale: '',
          sirenSouscripteur: '',
          nicSouscripteur: '',
          selectedMotifs: '',
          nir: '',
          nom: '',
          prenom: '',
          dateNaissance: '',
          dateEmbauche: '',
          dateEvenement: '',
          categorie: '',
          dateDebutPortabilite: '',
          dateFinPortabilite: '',
          dateSortie: '',
          typeSortie: '',
          commentaireMotif: '',
          attachment: '',
          mailTo: '',
          selecteddpcMailModele: '',
          selecteddpcCourrierModele: '',
          dpcCourrierDateRelance: '',
          affiliationOptionMensu: '',
          affiliationApprenti: '',
        },
      }
    },
    watch: {
      myData: {
        handler: _.debounce(function(value) {
          this.$event.emit('editDossier', 'Incidents',value);
        },2000),
        deep: true,
      },
      async dossier() {
        this.getMailTo();
        this.setCommentairesIncidents();
        await this.getIncidents();
        if (this.$parent.$parent.$parent.isConformiteDBCO) {
          this.dbcoIsConforme = this.$parent.$parent.$parent.dossier.is_conforme ? 'true' : 'false';
          if (!isEmpty(this.items)) {
            this.canContinueDbco = this.checkCanContinueDbco(this.items[0]);
          }
        }
      },
      selectedMotifs() {
        this.manageInfosAffiliationVisibility()
      },
      nirAffiliation() {
        if (!isEmpty(this.nirAffiliation)) {
          if (this.nirAffiliation.length <= 13) {
            this.$parent.$parent.$parent.nirWithoutKey = this.nirAffiliation;
            this.$parent.$parent.$parent.keyNir = '';
          } else if (this.nirAffiliation.length > 13) {
            this.$parent.$parent.$parent.nirWithoutKey = this.nirAffiliation.substring(0,13);
            this.$parent.$parent.$parent.keyNir = this.nirAffiliation.substring(13);
          }
        }
      },
      affiliationOptionMensuValue() {
        if (!isEmpty(this.affiliationOptionMensuValue)) {
          this.affiliationOptionMensu = 'true';
        }
      },
      affiliationOptionMensu() {
        if (this.affiliationOptionMensu === false) {
          this.affiliationOptionMensuValue = '';
        }
      },
    },
    computed: {
      piecesJointesInterne() {
        return _.filter(this.pieces_jointes, (pj) => pj.is_from_client === false);
      },
      piecesJointesExterne() {
        //return _.filter(this.dossier.pieces_jointes, (pj) => pj.is_from_client === true);
        return _.filter(this.pieces_jointes, (pj) => {
          let pjTypeLibTech = pj.types_pj ? pj.types_pj.map(type => type.libelle_technique) : [];
          return pj.is_from_client === true && pjTypeLibTech.indexOf('doublon') === -1 && pjTypeLibTech.indexOf('inutiles') === -1
        });
      },
    },
    created() {
      this.pieces_jointes = this.dossier.pieces_jointes
      this.getMailTo()
      this.$event.on('validateIncident', (valid) => {
        this.canSaveIncident = valid;
      });
      this.$event.on('initConformiteDBCO', (value) => {
        this.dbcoIsConforme = value;
      });
      this.$event.on('changeConformiteDBCO', (value) => {
        this.dbcoIsConforme = value;
        if (!isEmpty(this.items)) {
          this.canValidateDbcoSansAr = this.checkCanValidateDbcoSansAr(this.items[0]);
          this.canContinueDbco = this.checkCanContinueDbco(this.items[0]);
        }
      });
      this.$event.on('changementContact', (value) => {
        this.canSendArDbcoAgain = value === 'changed';
      });

      this.$event.on('refreshPjs', (pjs) => {
        this.pieces_jointes = pjs;
      });
    },
    async mounted() {
      //await this.getModels();
      await this.getIncidents();
      this.getMotifsAffiliation();
      this.setCommentairesIncidents();
      this.getSousStatusEnAttente();
      this.getCurrentTreatment();
      // this.getEnvironment();
      // On initialise la variable dbcoIsConforme
      this.dbcoIsConforme = this.dossier.is_conforme ? 'true' : 'false';
      if (!isEmpty(this.items)) {
        this.canValidateDbcoSansAr = this.checkCanValidateDbcoSansAr(this.items[0]);
        this.canContinueDbco = this.checkCanContinueDbco(this.items[0]);
      }

      // console.log('piecesJointesExterne',this.piecesJointesExterne);
      // console.log('piecesJointesInterne',this.piecesJointesInterne);

      // On initialise la variable StatusDPC
      this.statusDpc = this.$parent.$parent.$parent.statusEnAttente.sous_statuts.find(status => status.libelle_technique === 'en_attente_dpc');
      this.statusDpcAffiliation = this.$parent.$parent.$parent.statusEnAttente.sous_statuts.find(status => status.libelle_technique === 'en_attente_dpc_affiliation');
    },
    methods: {
      rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.statusPP && item.statusPP.libelle_technique === 'en_attente_dpc') return 'small-padding-y'
      },
      getDetailDpc(incident) {
        if (incident.dpc) {
          let email = '';
          let {date, type} = !isEmpty(incident.dpc.annual_reminder_at) ? {date: incident.dpc.annual_reminder_at, type: 'Relance annuelle'}
                          : (!isEmpty(incident.dpc.reminder3_at) ? {date: incident.dpc.reminder3_at, type: 'Relance 3'}
                            : (!isEmpty(incident.dpc.reminder2_at) ? {date: incident.dpc.reminder2_at, type: 'Relance 2'}
                              : (!isEmpty(incident.dpc.reminder1_at) ? {date: incident.dpc.reminder1_at, type: 'Relance 1'}
                                : (!isEmpty(incident.dpc.sent_at) ? {date: incident.dpc.sent_at, type: 'DPC'}
                                  : {date: null, type: null}))));
          if (date) {
            for (let mail of incident.dpc.dpc_mails) {
              if (mail.sent_at === date) {
                email = mail.to;
              } else {
                if (incident.dpc.type_dpc === 'courrier') email = 'courrier'
              }
            }
            return type + ' envoyé le ' + formatDateTime(date, '/') + ' à ' + email;
          }
        }
        return '';
      },
      isTraitement(type) {
        // Passer par une validation par type permet qu'aucun bouton ne s'affiche, plutot que le mauvais bouton, s'il y a un problème sur la récupération du currentTreatment
        return this.currentTreatment.type === type;
      },
      isTraitementByLibelle(libelleTechnique) {
        // Pour la validation DBCO, on s'assure que le user à bien le traitement
        if (libelleTechnique === 'validation_dbco') {
          let traitementValidationDbco = this.$parent.$parent.$parent.allTraitements.find(treatment => treatment.libelle_technique === 'validation_dbco');
          return this.currentTreatment.libelle_technique === libelleTechnique && getUserTraitementIds().indexOf(traitementValidationDbco.id) > -1;
        }
        return this.currentTreatment.libelle_technique === libelleTechnique;
      },
      getActionButtonLibelle() {
        return 'Clore "' + this.currentTreatment.libelle_court + '" et Ajouter une nouvelle action'
      },
      getMailTo() {
        if (this.dossier.contact_email) {
          this.mailTo = this.dossier.contact_email
        } else if (this.dossier.mail && this.dossier.mail.mail_from) {
          this.mailTo = this.dossier.mail.mail_from
        } else if (this.dossier.mail_declarant_sinistre) {
          this.mailTo = this.dossier.mail_declarant_sinistre
        }
      },
      setCommentairesIncidents() {
        this.allComments = this.dossier.commentaires_sinistre;
        if(this.allComments.length > 0) {
          this.lastComment = this.allComments[this.allComments.length - 1];
        }
      },
      incidentNotFinished(incident) {
        let statusTraiteIds = this.$parent.$parent.$parent.statusTraiteIds;
        // On met à part les incidents DPC qui sont un cas à part
        return incident.status_p_s && statusTraiteIds.indexOf(incident.status_p_s.id) === -1 && incident.statusPP.libelle_technique !== 'en_attente_dpc' && incident.statusPP.libelle_technique !== 'dpc_a_valider'
      },
      modifyIncident(incident) {
        incident.modifyStatusPP = !incident.modifyStatusPP;
        incident.can_edit = !incident.can_edit;
        incident.typeModif = incident.typeModif === '' ? 'changeType' : '';
      },
      cancel(incident) {
        let self = this
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment annuler cet incident ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:"#ff1744",
          confirmButtonText: 'retour',
          cancelButtonText: 'Annuler l\'incident',
        }).then((result) => {
          if (result.value !== true) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
              .get("/espaceGestion/incidents/delete/" + incident.id)
              .then(response => {
                this.$store.commit('IS_LOADING', false)
                this.manageChange()
                this.$swal({ position: 'top', type: 'success', title:'Annulation avec succès', text:'L\'incident a bien été annulé',showConfirmButton: false, timer: 3000})
              })
              .catch(function(error){
                console.log(error)
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de l\'annulation de l\'incident. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
              })
          }
        })
      },
      reject(incident) {
        let self = this
        // console.log('incident',incident)
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment refuser cet incident ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:"#ff1744",
          confirmButtonText: 'retour',
          cancelButtonText: 'Refuser l\'incident',
        }).then((result) => {
          if (result.value !== true) {
            let datPost = {
              dpc_mail_id: this.dpcMailId
            }
            this.$store.commit('IS_LOADING', true)
            this.$axios
              .post("/espaceGestion/incidents/reject/" + incident.id, datPost)
              .then(response => {
                this.$store.commit('IS_LOADING', false)
                this.manageChange()
                this.$swal({ position: 'top', type: 'success', title:'Refus avec succès', text:'L\'incident a bien été refusé',showConfirmButton: false, timer: 3000})
              })
              .catch(function(error){
                console.log(error)
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de l\'annulation de l\'incident. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
              })
          }
        })
      },
      canCancel(incident) {
        let can = false;
        if (incident.dpc) {
          can = !incident.dpc.sent_at
        } else {
          let statusAAffecterIds = [];
          statusAAffecterIds.push(this.$parent.$parent.$parent.statusAAffecter.id);
          for (let status of this.$parent.$parent.$parent.statusAAffecter.sous_statuts) {
            statusAAffecterIds.push(status.id);
          }
          can = statusAAffecterIds.indexOf(incident.statut) > -1;
        }
        // Cas des dossiers DBCO en lecture seul (type visible DBCO mais pas de traitement associé)
        let canDbco = true;
        let userTraitementLibelleTech = getUser().profil_active[0].traitements.map(traitement => traitement.libelle_technique);
        if (this.dossier.type && this.dossier.type.libelle_technique === 'dbco' && (userTraitementLibelleTech.indexOf('gestion_dbco') === -1 || userTraitementLibelleTech.indexOf('validation_dbco') === -1)) {
          canDbco = false;
        }
        return can && !this.canDelete(incident) && this.isResponsable() && canDbco;
      },
      canAddIncident() {
        let can = true;
        for (let status of this.dossier.status) {
          if(parseInt(status.pivot.traitement_id) === parseInt(this.$route.query.traitementId) && this.$parent.$parent.$parent.statusTraiteIds.indexOf(status.id) > -1) {
            can = false;
          }
        }
        // On regarde si le dossier a une affectation
        can = dossierHasAffectation(this.dossier, this.$route.query.traitementId) ? can : false;

        let userTraitementLibelleTech = getUser().profil_active[0].traitements.map(traitement => traitement.libelle_technique);

        if (this.$parent.$parent.$parent.isValidationConformiteDBCO) {
          can = false;
        } else if (this.dossier.type && this.dossier.type.libelle_technique === 'dbco' && userTraitementLibelleTech.indexOf('gestion_dbco') === -1) {
          can = false;
        } else if (this.currentTreatment.libelle_technique === "ij_module_prevoyance") {
          can = false
        }

        return can && this.canInitiateIncident();
      },
      addIncident(type) {
        if (!this.newElementAdded) {
          this.newElementAdded = true;
          this.items.push({
            dateCreation: new Date().toLocaleDateString('fr-FR'),
            sousStatut: '',
            traitementPP: '',
            criterePriorite: '',
            collaborateurCreateur: getUser().prenom + ' ' + getUser().nom,
            destinataire: '',
            collaborateurAffecte: '',
            statut: '',
            traitementPS: '',
            dateStatutPS: new Date().toLocaleDateString('fr-FR'),
            can_edit: true,
            new_added: true,
            type: type,
          });
        }
      },
      async save(incident) {
        let statutBlocageCotisation = this.$parent.$parent.$parent.statusEnAttente.sous_statuts.find(status => status.libelle_technique === 'en_attente_blocage_cotisations');
        let statutBlocageCotisationContentieux = this.$parent.$parent.$parent.statusEnAttente.sous_statuts.find(status => status.libelle_technique === 'en_attente_blocage_cotisations_contentieux');

        if (incident.sousStatut === statutBlocageCotisation.id || incident.sousStatut === statutBlocageCotisationContentieux.id) {
          if(isEmpty(this.nic) && this.initiateBlocageCotisation === false){
            this.nic = !isEmpty(this.dossier.nic) ? this.dossier.nic : (!isEmpty(this.dossier.arret) ? this.dossier.arret.nic : '');
            this.selectedIncident  = incident;
            this.$refs['modal-nic'].show();
            this.initiateBlocageCotisation = true;
            return;
          }else{
            if(this.validateNicform()){
              let nic = String(this.nic).padStart(5, '0');
              this.$parent.$parent.$parent.setNicFromIncident(nic);
              this.nic = '';
              this.initiateBlocageCotisation = false;
              this.$refs['modal-nic'].hide();
            }else{
              return;
            }
          }
        }

        this.$parent.$parent.$parent.clearErrors();
        this.newElementAdded = false;

        let data = {
          'dossier_id': this.dossier.id,
          'sous_status_id': incident.sousStatut,
          'traitement_pp_id': incident.type === 'add' ? parseInt(this.$route.query.traitementId) : this.getMainDossierTraitementId(),
          'typeModif': incident.typeModif,
          'utilisateur_createur_id': getUser().id,
        };

        if (incident.id) {
          if (this.$parent.$parent.$parent.isConformiteDBCO) {
            this.$parent.$parent.$parent.saveIncidentConformite = true;
            await this.$parent.$parent.$parent.getRequiredFields();
            if (this.$parent.$parent.$parent.validateSave()) {
              this.saveEdit(incident, data);
            } else {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Des données obligatories sont manquantes.",
                showConfirmButton: false,
                timer: 3000
              });
            }
          } else {
            this.saveEdit(incident, data);
          }
        } else {
          this.$event.emit('addIncident');
          if (this.canInitiateIncident()) {
            if (incident.sousStatut) {
              this.$event.emit('addIncident');
              if(this.canSaveIncident) {
                // Si traitement DBCO, comme on ne passe pas par les statuts mais par l'incident pour le traitement, il faut vérifier que tous les champs obligatoires sont remplis
                if (this.$parent.$parent.$parent.isConformiteDBCO) {
                  this.$parent.$parent.$parent.saveIncidentConformite = true;
                  await this.$parent.$parent.$parent.getRequiredFields();

                  if (this.$parent.$parent.$parent.validateSave()) {
                    await this.saveStore(incident, data);
                  } else {
                    this.$swal({
                      position: "top",
                      type: "error",
                      title: "Attention !!",
                      text: "Des données obligatories sont manquantes ou des erreurs sont présentes.",
                      showConfirmButton: false,
                      timer: 3000
                    });
                  }
                } else {
                  await this.saveStore(incident, data);
                }
              } else {
                this.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Des données obligatories sont manquantes.",
                  showConfirmButton: false,
                  timer: 2000
                });
              }
            } else {
              this.errors.incident = 'Vous devez choisir un type d\'incident.'
            }
          } else {
            this.$swal({
              position: 'top',
              type:'warning',
              title:'Attention !!',
              text:'Vous n\'avez pas les droits nécessaires pour déclarer un incident',
              showConfirmButton: false,
              timer: 5000
            })
          }
        }
      },
      saveEdit(incident, data) {
        let self = this;
        data.status_id = incident.statut;
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .post('/espaceGestion/incidents/edit/'+incident.id, data)
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            this.manageChange()
            this.$swal({
              position: 'top',
              type: 'success',
              title: 'Modification avec succès',
              text: 'L\'incident a bien été modifié',
              showConfirmButton: false,
              timer: 3000
            })
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false)
            console.log(error)
            let errorText = 'Une erreur est survenue lors de la modification de l\'incident. Si le problème persiste, merci de faire un ticket au support DOSI.'
            // if (error.response.status === 409) { errorText = 'Ce type d\'incident est déjà ouvert' }
            self.$swal({
              position: 'top',
              type:'error',
              title:'Attention !!',
              text:errorText,
              showConfirmButton: false,
              timer: 5000
            })
          })
      },
      async saveStore(incident,data) {
        let self = this;
        this.$parent.$parent.$parent.clearErrors();
        // On enregistre d'abord les modifications potentiellement faites sur le dossier
        // sauf dans le cas d'un closeAdd car on a déjà sauvegardé
        if (incident.type !== 'closeAdd') {
          await this.$parent.$parent.$parent.save('save');
        }
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .post('/espaceGestion/incidents/store', data)
          .then(async (response) => {
            this.$store.commit('IS_LOADING', false);
            let statusDpc = this.$parent.$parent.$parent.statusEnAttente.sous_statuts.find(status => status.libelle_technique === 'en_attente_dpc');
            let statusDpcAffiliation = this.$parent.$parent.$parent.statusEnAttente.sous_statuts.find(status => status.libelle_technique === 'en_attente_dpc_affiliation');
            let statutBlocageCotisation = this.$parent.$parent.$parent.statusEnAttente.sous_statuts.find(status => status.libelle_technique === 'en_attente_blocage_cotisations');
            let statutBlocageCotisationContentieux = this.$parent.$parent.$parent.statusEnAttente.sous_statuts.find(status => status.libelle_technique === 'en_attente_blocage_cotisations_contentieux');

            // On vide le commentaire s'il existe car on l'a enregistré
            this.myData.commentaire = '';
            this.manageChange();
            if (incident.sousStatut !== statusDpc.id && incident.sousStatut !== statusDpcAffiliation.id && !this.$parent.$parent.$parent.isConformiteDBCO && response.data.incident.traitementPsTechnique !== 'affiliation') {
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Création avec succès',
                text: 'L\'incident a bien été créé ',
                showConfirmButton: false,
                timer: 3000
              })
            }
            if (incident.sousStatut === statusDpc.id || incident.sousStatut === statusDpcAffiliation.id) {
              this.incidentId = response.data.incident.id;
              this.dpcContexte = incident.sousStatut === statusDpcAffiliation.id ? 'affiliation' : 'classique';
              // On pré-sélectionne le type de DPC en fonction de l'origine du dossier
              if (!isEmpty(this.dossier.cev_id)) {
                this.typeDpc = 'cev';
              } else {
                this.typeDpc = 'mail';
              }
              this.$refs['modal-type-dpc'].show();
            }

            let selectedStatus = this.$parent.$parent.$parent.statusEnAttente.sous_statuts.find(status => status.id === data.sous_status_id)
            if (incident.type === 'closeAdd' || selectedStatus.has_reopen_traitement_secondaire === true) {
              // On regarde si le gestionnaire posséde le traitement du nouvel incident, si c'est le cas on recharge la page avec le bon incident
              let userTraitementIds = getUserTraitementIds();
              if (userTraitementIds.indexOf(response.data.incident.traitement_ps_id) > -1) {
                let queries = _.clone(this.$route.query);
                queries.traitementId = response.data.incident.traitement_ps_id;
                this.$router.push({path: this.$route.path, query: queries})
                location.reload()
              }
            }

            if (this.$parent.$parent.$parent.isConformiteDBCO && (this.dossier.accuse_reception === 'ar_mail' || (this.dossier.type_support === 'email' && (this.dossier.accuse_reception === 'ar_sans' || this.dossier.accuse_reception === 'ar_non_renseigne') && this.dbcoIsConforme === 'false'))) {
              let incidentPrepare = {
                id: response.data.incident.id,
                dateCreation: new Date(response.data.incident.date_creation).toLocaleDateString("fr-FR"),
                sousStatut: response.data.incident.sous_status_id,
                statusPP: response.data.incident.status_p_p,
                traitementPP: response.data.incident.traitement_p_p,
                criterePriorite: response.data.incident.critere_priorite,
                collaborateurCreateur: response.data.incident.createur.prenom.substring(0,1).toUpperCase() + '. ' + response.data.incident.createur.nom,
                collaborateurCreateurId: response.data.incident.createur.id,
                destinataire: response.data.incident.status_p_p ? response.data.incident.status_p_p.destinataire : '',
                collaborateurAffecte: '',
                statut: response.data.incident.status_id,
                traitementPS: response.data.incident.traitement_p_s,
                traitementPsId: response.data.incident.traitement_ps_id,
                dateStatutPS: new Date(response.data.incident.date_status_ps).toLocaleDateString("fr-FR"),
                dpc: response.data.incident.dpc,
                gestionnaire_affecte: response.data.incident.gestionnaire_affecte,
                status_p_s: response.data.incident.status_p_s,
                mailConformite: response.data.incident.mail_conformite,
                can_edit: false,
                new_added: false,
                modifyStatusPP: false,
                typeModif: '',
              }
              // On repeuple les motifs rejet pour qu'ils soient visible dans le mail
              this.dossier.selectedMotifsRejet = [];
              for (let motif of this.dossier.motifs_rejet) {
                this.dossier.selectedMotifsRejet.push(motif.id);
              }
              await this.initiateMailDbco(incidentPrepare);

              this.$refs['modal-mail-dbco'].show();
            }

            // Cas de l'affiliation qui nécessite la complétude d'une fiche d'affiliation
            if (response.data.incident.traitementPsTechnique === 'affiliation') {
              this.selectedIncident = response.data.incident;
              await this.initiateAffiliationForm(response.data.incident);
              this.$refs['modal-affiliation'].show();
            }
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false)
            console.log(error)
            let errorText = 'Une erreur est survenue lors de la création de l\'incident. Si le problème persiste, merci de faire un ticket au support DOSI.'
            if (error.response !== undefined && error.response.status === 409) {
              console.log(error.response)
              errorText = error.response.data.message;
            }
            self.$swal({
              position: 'top',
              type:'error',
              title:'Attention !!',
              text:errorText,
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      closeMailDbcoModal() {
        this.$refs['modal-mail-dbco'].hide();
      },
      async closeAndSave(incident) {
        this.newIncident = incident;
        // Close current action
        let statusTraite = this.$parent.$parent.$parent.statusTraite;
        this.$parent.$parent.$parent.dossier.status_id = statusTraite.id;
        // Dans le cas d'un traitement de controle ou expert, il faut afficher la pop-up de validation des résultats.
        // On est obligé de le faire maintenant et de ne pas utiliser la fonction save() du $parent sinon on sort de la promise et elle ne se résoud jamais et on ne peut pas enregistrer le nouvel incident.
        // On vérifie donc dès à présent les autres validations
        if (this.$parent.$parent.$parent.currentTreatment.libelle_technique === 'ij_expertise_presta_niv2' || this.$parent.$parent.$parent.currentTreatment.libelle_technique === 'controle_prestation') {
          await this.$parent.$parent.$parent.getRequiredFields();
          if (this.$parent.$parent.$parent.validateSave()) {
            this.$parent.$parent.$parent.clearErrors();
            this.$refs['modal-resultat-motifAno'].show();
          }
        } else {
          await this.$parent.$parent.$parent.save('save');
          await this.timeout(2000);
          await this.save(incident);
        }
      },
      closeModalResultatAno() {
        this.newIncident = null;
        this.$parent.$parent.$parent.resultatIncident = '';
        this.$parent.$parent.$parent.motifAnomalie = '';
        this.$parent.$parent.$parent.commentaireControle = '';
        this.$parent.$parent.$parent.clearErrors();
        this.$refs['modal-resultat-motifAno'].hide();
      },
      async validateDataResultat() {
        this.$parent.$parent.$parent.clearErrors()
        // Resultat et motif principal anomalie pour incident à passer au statut traité
        let valid = true;
        if (this.$parent.$parent.$parent.currentTreatment.libelle_technique === 'controle_prestation') {
          if (isEmpty(this.$parent.$parent.$parent.resultatIncident)) {
            valid = false;
            this.$parent.$parent.$parent.errors.resultatIncident = "Veuillez choisir un résultat de contrôle.";
          }
          if ((this.$parent.$parent.$parent.resultatIncident !== this.$parent.$parent.$parent.resultatOKId) && isEmpty(this.$parent.$parent.$parent.motifAnomalie)) {
            valid = false;
            this.$parent.$parent.$parent.errors.motifAnomalie = "Veuillez choisir un motif principal anomalie.";
          }
        }
        if (valid === true) {
          await this.$parent.$parent.$parent.storeData('save');
          await this.timeout(2000);
          await this.save(this.newIncident);
        }
        return valid
      },
      canManageDbco(type) {
        let userTraitementLibelleTech = getUser().profil_active[0].traitements.map(traitement => traitement.libelle_technique);
        if (type === 'responsable') {
          return this.isResponsable() && (userTraitementLibelleTech.indexOf('gestion_dbco') > -1 || userTraitementLibelleTech.indexOf('validation_dbco') > -1);
        } else if (type === 'gestionnaire') {
          return !this.isResponsable() && (userTraitementLibelleTech.indexOf('gestion_dbco') > -1 || userTraitementLibelleTech.indexOf('validation_dbco') > -1);
        } else {
          return false;
        }
      },
      // async initiatePrint(incident) {
      //   await this.initiateMailDbco(incident);
      //   this.$refs['modal-print-dbco'].show();
      // },
      // print() {
      //   const modal = document.getElementById("block-print")
      //   const cloned = modal.cloneNode(true)
      //   let section = document.getElementById("print")

      //   if (!section) {
      //      section  = document.createElement("div")
      //      section.id = "print"
      //      document.body.appendChild(section)
      //   }

      //   section.innerHTML = "";
      //   section.appendChild(cloned);
      //   window.print();
      // },
      // getDateCourrier() {
      //   moment.locale('fr');
      //   return moment().format("dddd Do MMMM YYYY");
      // },
      async showMailDbco (incident) {
        await this.initiateMailDbco(incident);
        this.$refs['modal-mail-dbco'].show();
      },
      async showSentMailDbco (incident) {
        await this.getMailDbcoSent(incident);
        this.$refs['modal-mail-dbco-readOnly'].show();
      },
      initiateMailDbco(incident) {
        return new Promise(async resolve => {
          if (this.dpcMailModeles.length === 0 && this.dpcCevModeles.length === 0) {
            await this.getModels(incident);
          }
          // On récupère en priorité les données des input, si non présentes on prend celles enregistrées dans le dossier car tout est calculé en fonction des input pour la génération du mail
          this.incidentSelected = incident;

          let typeDbcoDossier = !isEmpty(this.dossier.dbcoType) ? this.dossier.dbcoType : this.dossier.dbco_type;
          let isConforme = !isEmpty(this.dossier.isConforme) ? this.dossier.isConforme : (this.dossier.is_conforme === true ? 'true' : 'false');
          let models = [];
          let infosSupNonConformeElectronique = [];

          // On récupère les modèle propre à DBCO et on choisit automatiquement celui qu'il faut prendre en fonction de isConforme
          for (let model of this.dpcMailModeles) {
            if ((model.type_model === 'dbco' && model.modele === 'dbco_db_c' && typeDbcoDossier.toLowerCase() === 'db')
              || (model.type_model === 'dbco' && model.modele === 'dbco_co_c' && typeDbcoDossier.toLowerCase() === 'co')) {
              models['conforme'] = model;
            }
            if ((model.type_model === 'dbco' && model.modele === 'dbco_db_nc' && typeDbcoDossier.toLowerCase() === 'db')
              || (model.type_model === 'dbco' && model.modele === 'dbco_co_nc' && typeDbcoDossier.toLowerCase() === 'co')) {
              models['non_conforme'] = model;
            }
            if (model.type_model === 'dbco' && model.modele === 'dbco_db_info_electronique' && typeDbcoDossier.toLowerCase() === 'db') {
              infosSupNonConformeElectronique['db'] = model;
            }
            if (model.type_model === 'dbco' && model.modele === 'dbco_co_info_electronique' && typeDbcoDossier.toLowerCase() === 'co') {
              infosSupNonConformeElectronique['co'] = model;
            }
            if (model.type_model === 'dbco' && model.modele === 'dbco_sg_c' && isConforme === 'true'
              || model.type_model === 'dbco' && model.modele === 'dbco_sgdb_nc' && isConforme === 'false' && typeDbcoDossier.toLowerCase() === 'db'
              || model.type_model === 'dbco' && model.modele === 'dbco_sgco_nc' && isConforme === 'false' && typeDbcoDossier.toLowerCase() === 'co') {
              this.mailDbcoSignature = model.message;
            }
          }
          // console.log('infosSup', infosSupNonConformeElectronique)
          let typeDbcoSujet = typeDbcoDossier === 'DB' ? 'désignation de bénéficiaire(s)' : (typeDbcoDossier === 'CO' ? 'choix d\'option' : '');
          let infosDbcoPapier = '';
          let infosDbcoElectronique = '';
          let mailDbcoTo = '';

          if (!isEmpty(this.$parent.$parent.$parent.email)) {
            mailDbcoTo = this.$parent.$parent.$parent.email;
          } else if (incident.mailConformite && incident.mailConformite.to) {
            mailDbcoTo = incident.mailConformite.to
          } else if (this.dossier.email) {
            mailDbcoTo = this.dossier.email;
          }
          this.mailDbcoTo = mailDbcoTo;
          this.mailDbcoSubject = 'Accusé de réception suite au traitement de votre ' + typeDbcoSujet + ' par nos services';
          this.mailDbcoCustom = !isEmpty(incident.mailConformite) && incident.mailConformite.text_custom ? incident.mailConformite.text_custom : '';

          this.titreModalDbco = isConforme === 'false' ? 'Envoi mail de non Conformité' : 'Envoi mail de Conformité';
          if (isConforme === 'true') {
            this.mailDbcoAuto = models['conforme'].message;
          } else if (isConforme === 'false') {
            this.mailDbcoAuto = models['non_conforme'].message;
            // let motifSelected = !isEmpty(this.dossier.selectedMotifsRejet) ? this.dossier.selectedMotifsRejet : [];
            let motifSelected = !isEmpty(this.dossier.selectedMotifsRejet) ? this.dossier.selectedMotifsRejet : this.dossier.motifs_rejet.map(motif => {return motif.id});

            let listMotifRejet = '<ul>';
            for (let motif of this.$parent.$parent.$parent.allMotifsRejet) {
              if (motifSelected.indexOf(motif.id) > -1) {
                listMotifRejet = listMotifRejet + '<li>' + motif.libelle + '</li>';
                // On regarde si c'est le motif Autre, auquel cas on affiche le bloc de précision
                if (motif.libelle_technique === 'co_autre_motif' || motif.libelle_technique === 'db_autre_motif') {
                  this.showPrecisionAutre = true;
                }
              }
            }
            listMotifRejet = listMotifRejet + '</ul>';

            let regexTabMotif = /\[tabMotif]/i;
            this.mailDbcoAuto = this.mailDbcoAuto.replace(regexTabMotif, listMotifRejet);

            if ((this.dossier.type_support === 'papier' || this.dossier.typeSupport === 'papier') && typeDbcoDossier == 'DB') {
              infosDbcoPapier = '<p>Nous vous invitons à lire attentivement les instructions de rédaction figurant au dos de la nouvelle désignation jointe à la présente avant de la compléter <u>en lettres capitales</u> et à nous la retourner datée et signée par voie postale.</p>'
            }

            if ((this.dossier.type_support === 'email' || this.dossier.typeSupport === 'email') && typeDbcoDossier == 'DB') {
              infosDbcoElectronique = infosSupNonConformeElectronique['db'].message;
            } else if ((this.dossier.type_support === 'email' || this.dossier.typeSupport === 'email') && typeDbcoDossier == 'CO') {
              infosDbcoElectronique = infosSupNonConformeElectronique['co'].message;
            }
          }
          // let regexPrecisionMotifAutre = /\[precisionMotifAutre]/i;
          // let regexNom = /\[prenom_nom]/i;
          let regexInfoDbcoPapier = /\[infoDbco_papier]/i;
          this.mailDbcoSignature = this.mailDbcoSignature.replace(regexInfoDbcoPapier, infosDbcoPapier);

          let regexInfoDbcoElectronique = /\[infoDbco_electronique]/i;
          this.mailDbcoSignature = this.mailDbcoSignature.replace(regexInfoDbcoElectronique, infosDbcoElectronique);
          // this.mailDbcoAuto = this.mailDbcoAuto.replace(regexPrecisionMotifAutre, precisionMotifAutre);
          // this.mailDbcoAuto = this.mailDbcoAuto.replace(regexNom, this.dossier.prenom+' '+this.dossier.nom);
          this.mailDbcoPiecesJointes = incident.mailConformite ? incident.mailConformite.pieces_jointes : [];
          // console.log('this.mailDbcoPiecesJointes',this.mailDbcoPiecesJointes)
          resolve();
        })
      },
      getMailDbcoSent(incident) {
        return new Promise(resolve => {
          // On récupère en priorité les données des input, si non présentes on prend celles enregistrées dans le dossier car tout est calculé en fonction des input pour la génération du mail
          this.incidentSelected = incident;

          this.mailDbcoTo = incident.mailConformite.to;
          this.mailDbcoCc = incident.mailConformite.cc;
          this.mailDbcoSubject = incident.mailConformite.subject;
          this.mailDbcoAuto = incident.mailConformite.text_auto;
          this.mailDbcoCustom = incident.mailConformite.text_custom;
          this.mailDbcoSignature = incident.mailConformite.signature;
          this.mailDbcoPiecesJointes = incident.mailConformite.pieces_jointes;

          resolve();
        })
      },
      async initiateSaveMailDbco(type) {
        // si on est dans le cas d'un envoi, il faut vérifier que tous les champs obligatoires sont remplis avant de sauvegarder
        if (type === 'save') {
          await this.$parent.$parent.$parent.save('save');
          this.saveMailDbco(type);
        } else {
          this.$parent.$parent.$parent.saveIncidentConformite = true;
          await this.$parent.$parent.$parent.getRequiredFields();

          if (this.$parent.$parent.$parent.validateSave()) {
            await this.$parent.$parent.$parent.save('save');
            this.saveMailDbco(type);
          } else {
            this.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Des données obligatories sont manquantes.",
              showConfirmButton: false,
              timer: 3000
            });
          }
        }
      },
      saveMailDbco(type) {
        let self = this;
        let formData = new FormData();
        for( var i = 0; i < this.dpcAttachments.length; i++ ){
            let file = this.dpcAttachments[i];
            formData.append('files[' + i + ']', file)
        }
        formData.append('incident_id', this.incidentSelected.id);
        formData.append('mail_to', this.mailDbcoTo);
        formData.append('mail_cc', this.mailDbcoCc);
        formData.append('mail_subject', this.mailDbcoSubject);
        formData.append('mail_body_auto', this.mailDbcoAuto);
        formData.append('mail_body_custom', this.mailDbcoCustom);
        formData.append('mail_signature', this.mailDbcoSignature);
        formData.append('save_type', type);
        formData.append('traitement_id', this.$route.query.traitementId);

        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/incidents/dbco/save', formData, {headers: {'Content-Type': 'multipart/form-data'}})
          .then((response) => {
            this.$store.commit('IS_LOADING', false)
            this.manageChange();
            this.closeModal('modal-mail-dbco');
            this.dpcAttachments = [];
            // Dans le cas d'un RE qui valide la DBCO, on empêche le bouton "continuer mail DBCO" de s'afficher
            if (type === 'valideAndSend') {
              this.canContinueDbco = false;
            }

            let textSwal = type === 'valideAndSend' ? 'Le mail a bien été envoyé' : type === 'send' ? 'Le mail est bien parti en validation' : 'Le mail a bien été enregistré';
            this.$swal({
              position: 'top',
              type: 'success',
              title: 'Création avec succès',
              text: textSwal,
              showConfirmButton: false,
              timer: 3000
            })
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false)
            console.log(error)
            let errorText = 'Une erreur est survenue lors de l\'enregistrement/envoie du mail. Si le problème persiste, merci de faire un ticket au support DOSI.'
            self.$swal({
              position: 'top',
              type:'error',
              title:'Attention !!',
              text:errorText,
              showConfirmButton: false,
              timer: 5000
            })
          })
      },
      validateDbcoSansAr(incident) {
        let self = this

        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment valider cette DBCO ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:"#ff1744",
          confirmButtonText: 'Valider',
          cancelButtonText: 'Annuler',
        }).then(async (result) => {
          if (result.value === true) {
            await this.$parent.$parent.$parent.save('save');
            this.$store.commit('IS_LOADING', true)
            this.$axios
              .get('/espaceGestion/incidents/dbco/validate/'+incident.id)
              .then(async (response) => {
                this.$store.commit('IS_LOADING', false)
                this.manageChange();
                this.items = [];
                let typeDbcoDossier = !isEmpty(this.dossier.dbcoType) ? this.dossier.dbcoType : this.dossier.dbco_type;
                let textSwal = typeDbcoDossier.toLowerCase() === 'db' ? 'La validation de la désignation de bénéficiaire a bien été enregistrée' : 'La validation du choix d\'option a bien été enregistrée';
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Création avec succès',
                  text: textSwal,
                  showConfirmButton: false,
                  timer: 3000
                });
                // On met à jour l'incident avec la réponse du middle et on recalcul la visibilité de la coche de validation
                await this.addIncidentToList(response.data.incident);
                this.canValidateDbcoSansAr = this.checkCanValidateDbcoSansAr(this.items[0]);
              })
              .catch((error) => {
                self.$store.commit('IS_LOADING', false)
                console.log(error)
                let errorText = 'Une erreur est survenue lors de la validation de la DB/CO. Si le problème persiste, merci de faire un ticket au support DOSI.'
                self.$swal({
                  position: 'top',
                  type:'error',
                  title:'Attention !!',
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          }
        })
      },
      validateDbcoCourrier(incident) {

      },
      deleteIncident(item) {
        let self = this
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment supprimer cet incident ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:"#ff1744",
          confirmButtonText: 'Annuler',
          cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (result.value !== true) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
              .get("/espaceGestion/incidents/delete/" + item.id)
              .then(response => {
                this.$store.commit('IS_LOADING', false)
                this.manageChange()
                this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'L\'incident a bien été supprimé',showConfirmButton: false, timer: 3000})
              })
              .catch(function(error){
                console.log(error)
                self.$store.commit('IS_LOADING', false)
                self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue lors de la suppression de l\'incident. Si le problème persiste, merci de faire un ticket au support DOSI.',showConfirmButton: false, timer: 5000})
              })
          }
        })
      },
      getCriterePriorite() {
        var response = '';
        let incidentPrioritaire = this.incidents.reduce((res, incident) => {
          if (res) {
            return incident.status_p_p.critere_priorite && res.critere_priorite > incident.critere_priorite ? incident : res;
          } else {
            return incident.critere_priorite;
          }
        },{critere_priorite: 99, status_p_p: {libelle_bo: ''}})

        return incidentPrioritaire.status_p_p.libelle_bo;
      },
      getDestinataire(incident) {
        if (incident.statusPP) {
          return incident.statusPP.libelle_destinataire_ps !== undefined ? incident.statusPP.libelle_destinataire_ps : '';
        }
        return '';
      },
      getCollaborateurPS(incident) {
        let colaborateurPS = ''

        if (incident.gestionnaire_affecte) {
          colaborateurPS = incident.gestionnaire_affecte.prenom.substring(0,1).toUpperCase() + '. ' + incident.gestionnaire_affecte.nom
        }
        return colaborateurPS
      },
      getStatusPS(incident) {
        let statusPs = ''
        if (incident.status_p_s) {
          statusPs = incident.status_p_s.libelle_bo
        }

        return statusPs
      },
      isDisabled(field) {
        if (field === 'sousStatut' && (this.isTreatment('qualification_courrier') || this.isTreatment('ij_module_prevoyance') || this.isTreatment('ij_expertise_presta'))) {
          return true;
        }
      },
      getSousStatusEnAttente() {
        let data = [];
        // if (!isEmpty(this.$parent.$parent.$parent.statusEnAttente.sous_statuts)) {
        //   data = [...this.$parent.$parent.$parent.statusEnAttente.sous_statuts]
        // }
        if (!isEmpty(this.$parent.$parent.$parent.currentTreatment.status)) {
          data = [...this.$parent.$parent.$parent.currentTreatment.status]
        }
        let statusEnAttenteId = 27;
        if (!isEmpty(this.$parent.$parent.$parent.statusEnAttente.sous_statuts)) {
          statusEnAttenteId = this.$parent.$parent.$parent.statusEnAttente.id;
        }

        this.sousStatusEnAttenteOptions = [];
        data = data.filter(status => status.parent_id === parseInt(statusEnAttenteId,10));
        data.sort((a, b) => { return a.libelle_bo.localeCompare(b.libelle_bo) })

        // this.sousStatusEnAttenteOptions = [];
        // data = _.filter(data, (element) => {
        //   let keep = true;
        //   if (element.libelle_technique !== 'en_attente_dpc' && this.isTreatment('qualification_courrier')) {
        //     keep = false;
        //   }
        //   if ((element.libelle_technique !== 'en_attente_validation_dbco' && this.$parent.$parent.$parent.isConformiteDBCO) || (element.libelle_technique === 'en_attente_validation_dbco' && !this.$parent.$parent.$parent.isConformiteDBCO)) {
        //     keep = false;
        //   }
        //   return keep && element.libelle_technique !== 'dpc_a_valider' && element.libelle_technique !== 'refus_a_valider' && element.libelle_technique !== 'en_attente_integration_fichier';
        // });
        for (let sousStatus of data) {
          this.sousStatusEnAttenteOptions.push({value: sousStatus.id, text: sousStatus.libelle_bo});
        }
      },
      getIncidents() {
        return new Promise(async (resolve, reject) => {
          let self = this
          this.items = [];
          await this.$axios
            .get("/espaceGestion/incidents/dossierId/" + this.dossier.id)
            .then(response => {
              this.items = [];
              this.incidents = response.data.incidents
              for (let incident of response.data.incidents) {
                this.addIncidentToList(incident)
              }
              this.$event.emit('stopLoadingIncident');
              resolve();
            })
            .catch((error) => {
              // self.$store.commit('IS_LOADING', false)
              console.log(error)
              let errorText = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.'
              self.$swal({
                position: 'top',
                type:'error',
                title:'Attention !!',
                text:errorText,
                showConfirmButton: false,
                timer: 5000
              })
              resolve();
            })
        })
      },
      getMotifsAffiliation() {
        return new Promise(async (resolve, reject) => {
          let self = this
          this.allMotifsAffiliation = [];
          this.motifsAffiliation = [];
          await this.$axios
            .get("/espaceGestion/incidents/motif-affiliation")
            .then(response => {
              this.allMotifsAffiliation = response.data.motifs;
              this.motifsAffiliation = _.groupBy(response.data.motifs, 'type');
              // console.log(this.allMotifsAffiliation,this.motifsAffiliation)
              resolve();
            })
            .catch((error) => {
              // self.$store.commit('IS_LOADING', false)
              console.log(error)
              let errorText = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.'
              self.$swal({
                position: 'top',
                type:'error',
                title:'Attention !!',
                text:errorText,
                showConfirmButton: false,
                timer: 5000
              })
              resolve();
            })
        })
      },
      addIncidentToList(incident) {
        return new Promise(async (resolve, reject) => {
          let showDetail = incident.statusPP && incident.statusPP.libelle_technique === 'en_attente_dpc' ? true : false;
          this.items.push({
            id: incident.id,
            dateCreation: new Date(incident.date_creation).toLocaleDateString("fr-FR"),
            sousStatut: incident.sous_status_id,
            statusPP: incident.status_p_p,
            traitementPP: incident.traitement_p_p,
            criterePriorite: incident.critere_priorite,
            collaborateurCreateur: incident.createur.prenom.substring(0,1).toUpperCase() + '. ' + incident.createur.nom,
            collaborateurCreateurId: incident.createur.id,
            destinataire: incident.status_p_p ? incident.status_p_p.destinataire : '',
            collaborateurAffecte: '',
            statut: incident.status_id,
            traitementPS: incident.traitement_p_s,
            traitementPsId: incident.traitement_ps_id,
            dateStatutPS: new Date(incident.date_status_ps).toLocaleDateString("fr-FR"),
            dpc: incident.dpc,
            gestionnaire_affecte: incident.gestionnaire_affecte,
            status_p_s: incident.status_p_s,
            mailConformite: incident.mail_conformite,
            can_edit: false,
            new_added: false,
            modifyStatusPP: false,
            typeModif: '',
            donnee_affiliation: incident.donnee_affiliation,
            resultatControle: incident.resultat_controle_dossiers ? incident.resultat_controle_dossiers.libelle : '',
            motifPrincipal: incident.motif_principal_ano ? incident.motif_principal_ano.libelle : '',
            commentaireControle: incident.commentaire,
            _showDetails: showDetail
          });
          resolve();
        })
      },
      async showNicForm(incident) {
        //this.selectedIncident = incident;
        //await this.initiateAffiliationForm(incident);
        this.$refs['modal-nic'].show();
      },
      async closeModalNic(){
        this.initiateBlocageCotisation = false;
        this.$refs['modal-nic'].hide();
      },
      async showAffiliationForm(incident) {
        this.selectedIncident = incident;
        await this.initiateAffiliationForm(incident);
        this.$refs['modal-affiliation'].show();
      },
      initiateAffiliationForm(incident) {
        return new Promise(async (resolve, reject) => {
          if (!isEmpty(incident.donnee_affiliation)) {
            this.sirenSouscripteur = incident.donnee_affiliation.siren_souscripteur;
            this.nicSouscripteur = incident.donnee_affiliation.nic_souscripteur;
            this.nic = incident.donnee_affiliation.nic;
            this.raisonSociale = incident.donnee_affiliation.denomination;
            this.nirAffiliation = !isEmpty(incident.donnee_affiliation.nir) ? incident.donnee_affiliation.nir : (!isEmpty(this.dossier.nir) ? this.dossier.nir : this.$parent.$parent.$parent.nirWithoutKey + this.$parent.$parent.$parent.keyNir);
            this.dateEmbauche = incident.donnee_affiliation.date_embauche;
            this.dateEvenement = incident.donnee_affiliation.date_evenement;
            this.categorie = incident.donnee_affiliation.categorie;
            this.selectedMotifs = incident.donnee_affiliation.motifs;
            this.dateDebutPortabilite = incident.donnee_affiliation.date_debut_portabilite;
            this.dateFinPortabilite = incident.donnee_affiliation.date_fin_portabilite;
            this.dateSortie = incident.donnee_affiliation.date_sortie;
            this.typeSortie = incident.donnee_affiliation.type_sortie;
            this.commentaireMotif = incident.donnee_affiliation.commentaire_motif;
            this.affiliationOptionMensu = incident.donnee_affiliation.option_mensu;
            this.affiliationOptionMensuValue = incident.donnee_affiliation.option_mensu_value;
            this.affiliationApprenti = incident.donnee_affiliation.apprenti;
          } else {
            this.raisonSociale = this.dossier.siren_entity ? this.dossier.siren_entity.raison_sociale : (!isEmpty(this.dossier.arret) && this.dossier.arret.raison_sociale ? this.dossier.arret.raison_sociale : '');
            this.nirAffiliation = this.dossier.nir ? this.dossier.nir : this.$parent.$parent.$parent.nirWithoutKey + this.$parent.$parent.$parent.keyNir;
            this.dateEmbauche = !isEmpty(this.dossier.arret) ? this.dossier.arret.date_embauche : '';
            this.categorie = !isEmpty(this.dossier.arret) ? this.dossier.arret.statut_salarie.toLowerCase() : '';
            this.nic = !isEmpty(this.dossier.nic) ? this.dossier.nic : (!isEmpty(this.dossier.arret) ? this.dossier.arret.nic : '');
            if (isEmpty(this.$parent.$parent.$parent.date_naissance)) {
              this.$parent.$parent.$parent.date_naissance = !isEmpty(this.dossier.arret) ? this.dossier.arret.date_naissance : '';
            }
          }
          resolve();
        });
      },
      canContinueAffiliation(incident) {
        return !isEmpty(incident.statusPP) && incident.statusPP.libelle_technique === 'a_traiter_creation_demande_affiliation';
      },
      canShowAffiliation(incident) {
        return !isEmpty(incident.statusPP) && (incident.statusPP.libelle_technique === 'en_attente_demande_affiliation' || incident.statusPP.libelle_technique === 'a_traiter_retour_affiliation');
      },
      async showAffiliationFiche(incident) {
        incident.visu = 'readOnly';
        this.selectedIncident = incident;
        await this.initiateAffiliationForm(incident);
        this.$refs['modal-affiliation'].show();
      },
      checkDisableCheckboxAffiliation(motif) {
        if (this.selectedIncident.visu === 'readOnly') {
          return true;
        }
        let type = '';
        for (let motifAffiliation of this.selectedMotifs) {
          type = motifAffiliation.type;
        }
        // On disable les champs qui ne sont pas du même type (création ou modification). Si vide on enable les deux
        if (isEmpty(this.selectedMotifs)) {
          return false;
        } else {
          return motif.type !== type
        }
      },
      manageInfosAffiliationVisibility() {
        let findPortabilite = false;
        let type = '';
        for (let motif of this.selectedMotifs) {
          if (motif.libelle_technique === 'portabilite') {
            findPortabilite = true;
          }
        }
        // Si la portabilité fait partie des motifs, on affiche les champs concernés, sinon on vide les champs
        this.showInfosPortabilite = findPortabilite;
        if (!findPortabilite) {
          this.dateDebutPortabilite = null;
          this.dateFinPortabilite = null;
          this.dateSortie = null;
          this.typeSortie = null;
        }
      },
      saveAffiliationForm(type) {
        this.clearErrorsAffiliation();
        if (type === 'save' || this.validateAffiliationForm()) {
          this.storeAffiliation(type);
        }
      },
      async storeAffiliation(type) {
        let self = this;
        this.clearErrorsAffiliation();
        this.$store.commit('IS_LOADING', true);
        // On enregistre d'abord les modifications potentiellement faites sur le dossier via les champs commun entre le formulaire d'affiliation et le dossier
        await this.$parent.$parent.$parent.save('save');
        // Ensuite on enregistre le formulaire d'affiliation
        let postData = {
          siren: this.$parent.$parent.$parent.siren,
          nic: this.nic,
          raisonSociale: this.raisonSociale,
          sirenSouscripteur: this.sirenSouscripteur,
          nicSouscripteur: this.nicSouscripteur,
          nir: this.nirAffiliation,
          nom: this.$parent.$parent.$parent.nom,
          prenom: this.$parent.$parent.$parent.prenom,
          familleProduitId: this.$parent.$parent.$parent.selectedFamilleProduit,
          selectedMotifs: this.selectedMotifs,
          dateNaissance: this.$parent.$parent.$parent.date_naissance,
          dateEmbauche: this.dateEmbauche,
          dateEvenement: this.dateEvenement,
          categorie: this.categorie,
          dateDebutPortabilite: this.dateDebutPortabilite,
          dateFinPortabilite: this.dateFinPortabilite,
          typeSortie: this.typeSortie,
          dateSortie: this.dateSortie,
          commentaireMotif: this.commentaireMotif,
          optionMensu: this.affiliationOptionMensu,
          optionMensuValue: this.affiliationOptionMensuValue,
          apprenti: this.affiliationApprenti,
          incidentId: this.selectedIncident.id,
          typeSauvegarde: type,
          traitementId: this.$route.query.traitementId,
        }
        this.$axios
          .post('/espaceGestion/incidents/affiliation/store', postData)
          .then(async (response) => {
            this.$store.commit('IS_LOADING', false);
            this.selectedIncident = {};
            this.$refs['modal-affiliation'].hide();
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false)
            console.log(error)
            let errorText = 'Une erreur est survenue lors de l\'enregistrement de la fiche d\'affiliation. Si le problème persiste, merci de faire un ticket au support DOSI.'
            // if (error.response !== undefined && error.response.status === 409) {
            //   console.log(error.response)
            //   errorText = error.response.data.message;
            // }
            self.$swal({
              position: 'top',
              type:'error',
              title:'Attention !!',
              text:errorText,
              showConfirmButton: false,
              timer: 5000
            })
          });
      },
      validateNicform() {
        this.errors.nic = '';
        let valid = true;

        if (isEmpty(this.nic)) {
          valid = false;
          this.errors.nic = 'Vous devez saisir le NIC';
        }else{
          let nic = String(this.nic).padStart(5, '0');
          if (!checkSIRET(this.$parent.$parent.$parent.siren + nic)) {
            valid = false;
            this.errors.nic = 'Vous devez saisir un NIC valide';
          }
        }

        return valid;
      },
      validateAffiliationForm() {
        this.clearErrorsAffiliation();
        let valid = true;

        if (isEmpty(this.$parent.$parent.$parent.siren)) {
          valid = false;
          this.errors.siren = 'Vous devez saisir le SIREN';
        } else {
          let regexp = /[ \-_\.]/g;
          let cleanedSiren = this.$parent.$parent.$parent.siren.replace(regexp, '');
          if (cleanedSiren.length < 9) {
            valid = false;
            this.errors.siren = 'Le SIREN ne contient pas 9 chiffres';
          }
        }
        if (isEmpty(this.nic)) {
          valid = false;
          this.errors.nic = 'Vous devez saisir le NIC';
        }
        if (!isEmpty(this.$parent.$parent.$parent.siren) && !isEmpty(this.nic)) {
          let nic = String(this.nic).padStart(5, '0');
          if (!checkSIRET(this.$parent.$parent.$parent.siren + nic)) {
            valid = false;
            this.errors.nic = 'Vous devez saisir un NIC valide';
          }
        }
        if (isEmpty(this.raisonSociale)) {
          valid = false;
          this.errors.raisonSociale = 'Vous devez saisir la dénomination';
        }
        if (isEmpty(this.nirAffiliation)) {
          valid = false;
          this.errors.nir = 'Vous devez saisir le nir';
        } else if (this.nirAffiliation.length < 15) {
          valid = false;
          this.errors.nir = 'Vous devez saisir le nir complet avec la clé';
        }
        if (isEmpty(this.$parent.$parent.$parent.nom)) {
          valid = false;
          this.errors.nom = 'Vous devez saisir le nom de l\'assuré';
        }
        if (isEmpty(this.$parent.$parent.$parent.prenom)) {
          valid = false;
          this.errors.prenom = 'Vous devez saisir le prénom de l\'assuré';
        }
        if (isEmpty(this.$parent.$parent.$parent.selectedFamilleProduit) || parseInt(this.$parent.$parent.$parent.selectedFamilleProduit,10) === 35) {
          valid = false;
          this.errors.familleProduit = 'Vous devez séléctionner un produit';
        }
        if (isEmpty(this.selectedMotifs)) {
          valid = false;
          this.errors.selectedMotifs = 'Vous devez choisir un motif d\'affiliation d\'urgence';
        }
        if (isEmpty(this.$parent.$parent.$parent.date_naissance)) {
          valid = false;
          this.errors.dateNaissance = 'Vous devez saisir la date de naissance réelle de l\'assuré';
        }
        if (isEmpty(this.dateEmbauche)) {
          valid = false;
          this.errors.dateEmbauche = 'Vous devez saisir la date d\'embauche';
        } else {
          let dateEmbauche = new Date(this.dateEmbauche).getTime();
          let dateJour = new Date().getTime();
          if (dateEmbauche > dateJour) {
            valid = false;
            this.errors.dateEmbauche = 'La date d\'embauche ne peut être supérieure à la date du jour';
          }
        }
        if (isEmpty(this.dateEvenement)) {
          valid = false;
          this.errors.dateEvenement = 'Vous devez saisir la date d\'événement';
        } else {
          let dateEvenement = new Date(this.dateEvenement).getTime();
          let dateReception = new Date(this.dossier.date_reception).getTime();
          if (dateEvenement > dateReception) {
            valid = false;
            this.errors.dateEvenement = 'La date d\'évènement ne peut être supérieure à la date de réception';
          }
        }
        if (!isEmpty(this.dateEvenement) && !isEmpty(this.dateEmbauche)) {
          let dateEvenement = new Date(this.dateEvenement).getTime();
          let dateEmbauche = new Date(this.dateEmbauche).getTime();
          if (dateEvenement < dateEmbauche) {
            valid = false;
            this.errors.dateEvenement = isEmpty(this.errors.dateEvenement) ? 'La date d\'évènement et la date d\'embauche ne sont pas compatible avec une demande d\'affiliation' : this.errors.dateEvenement + '; La date d\'évènement et la date d\'embauche ne sont pas compatible avec une demande d\'affiliation';
          }
        }
        if (isEmpty(this.categorie)) {
          valid = false;
          this.errors.categorie = 'Vous devez choisir la catégorie du salarié';
        }
        if (!isEmpty(this.selectedMotifs)) {
          let findPortabilite = this.selectedMotifs.find(motif => motif.libelle_technique === 'portabilite');
          if (findPortabilite) {
            if (isEmpty(this.dateDebutPortabilite)) {
              valid = false;
              this.errors.dateDebutPortabilite = 'Vous devez saisir la date de début de portabilité';
            }
            if (isEmpty(this.dateFinPortabilite)) {
              valid = false;
              this.errors.dateFinPortabilite = 'Vous devez saisir la date de fin de portabilité';
            }
            if (isEmpty(this.typeSortie)) {
              valid = false;
              this.errors.typeSortie = 'Vous devez choisir quel type de sortie';
            }
            if (isEmpty(this.dateSortie)) {
              valid = false;
              this.errors.dateSortie = 'Vous devez saisir la date de sortie';
            }
          }
          // let findContratOptionFacultatif = this.selectedMotifs.find(motif => motif.libelle_technique === 'contrat_option_facultatif');
          // if (findContratOptionFacultatif && isEmpty(this.commentaireMotif)) {
          //   valid = false;
          //   this.errors.commentaireMotif = 'Vous devez renseigner la zone commentaire';
          // }
        }
        if (!isEmpty(this.sirenSouscripteur) && isEmpty(this.nicSouscripteur)) {
          valid = false;
          this.errors.nicSouscripteur = 'Vous devez saisir le NIC souscripteur';
        } else if (!isEmpty(this.sirenSouscripteur)) {
          let regexp = /[ \-_\.]/g;
          let cleanedSirenSous = this.sirenSouscripteur.replace(regexp, '');
          if (cleanedSirenSous.length < 9) {
            valid = false;
            this.errors.sirenSouscripteur = 'Le SIREN souscripteur ne contient pas 9 chiffres';
          }
        }
        if (!isEmpty(this.sirenSouscripteur) && !isEmpty(this.nicSouscripteur)) {
          let nicSouscripteur = String(this.nicSouscripteur).padStart(5, '0');
          if (!checkSIRET(this.sirenSouscripteur + nicSouscripteur)) {
            valid = false;
            this.errors.nicSouscripteur = 'Vous devez saisir un NIC souscripteur valide';
          }
        }

        if (this.affiliationOptionMensu === 'true') {
          if (isEmpty(this.affiliationOptionMensuValue)) {
            valid = false;
            this.errors.affiliationOptionMensu = 'Vous devez choisir le type d\'option';
          }
        }

        if (this.dossier.famille_produit_id === 37) {
          if (isEmpty(this.affiliationApprenti)) {
            valid = false;
            this.errors.affiliationApprenti = 'Vous devez choisir une option';
          }
        }

        return valid;
      },
      showOptionMensu() {
        return this.dossier.famille_produit_id === 8;
      },
      showApprenti() {
        return this.dossier.famille_produit_id === 37;
      },
      clearErrorsAffiliation() {
        this.errors.siren = '';
        this.errors.nic = '';
        this.errors.sirenSouscripteur = '';
        this.errors.nicSouscripteur = '';
        this.errors.familleProduit = '';
        this.errors.raisonSociale = '';
        this.errors.selectedMotifs = '';
        this.errors.nir = '';
        this.errors.nom = '';
        this.errors.prenom = '';
        this.errors.dateNaissance = '';
        this.errors.dateEmbauche = '';
        this.errors.dateEvenement = '';
        this.errors.categorie = '';
        this.errors.dateDebutPortabilite = '';
        this.errors.dateFinPortabilite = '';
        this.errors.dateSortie = '';
        this.errors.typeSortie = '';
        this.errors.commentaireMotif = '';
        this.errors.affiliationOptionMensu = '';
        this.errors.affiliationApprenti = '';
      },
      canDelete(item) {
        // // 1. On s'assure d'avoir un tableau
        let emails = (item && item.dpc && Array.isArray(item.dpc.dpc_mails)) ? item.dpc.dpc_mails : [];

        // 2. `.some()` vérifie si AU MOINS UN élément remplit la condition
        // Renvoie true si un mail a été refusé (is_validation_ok === false), sinon false
        let emailValidationIsFalse = emails.some(function(mail) {
          return mail && mail.is_validation_ok === false;
        });

        let isResponsable = this.isResponsable();
        let user = getUser();
        let userTraitementLibelleTech = getUser().profil_active[0].traitements.map(traitement => traitement.libelle_technique);

        let isTraitementPsAAffecter = parseInt(item.statut) === parseInt(this.$parent.$parent.$parent.statusAAffecter.id);

        let traitementDbcoEnAttenteValidation = (parseInt(item.statut) === parseInt(this.$parent.$parent.$parent.statusEnAttente.id) && (this.$parent.$parent.$parent.isConformiteDBCO || this.$parent.$parent.$parent.isValidationConformiteDBCO) && (userTraitementLibelleTech.indexOf('gestion_dbco') > -1 || userTraitementLibelleTech.indexOf('validation_dbco') > -1));

        let statusDpcAffiliation = this.$parent.$parent.$parent.statusEnAttente.sous_statuts.find(status => status.libelle_technique === 'en_attente_dpc_affiliation');
        let statusEncoursDpc = this.$parent.$parent.$parent.statusATraiter.sous_statuts.find(status => status.libelle_technique === 'a_traiter_en_cours_creation_dpc');
        let statusEncoursDpcAffiliation = this.$parent.$parent.$parent.statusATraiter.sous_statuts.find(status => status.libelle_technique === 'a_traiter_en_cours_creation_dpc_affiliation');

        // isEnAttenteDpc prend aussi en compte les en cours de création de DPC
        let isEnAttenteDpc = (
          (this.$parent.$parent.$parent.statusEnAttenteIds.indexOf(parseInt(item.statut)) > -1 && (parseInt(item.sousStatut,10) === parseInt(this.$parent.$parent.$parent.statusEnAttenteDpc.id,10) || parseInt(item.sousStatut,10) === parseInt(statusDpcAffiliation.id,10)))
          ||
          ( this.$parent.$parent.$parent.statusATraiterIds.indexOf(parseInt(item.statut)) > -1 && (parseInt(item.sousStatut,10) === parseInt(statusEncoursDpc.id,10)  || parseInt(item.sousStatut,10) === parseInt(statusEncoursDpcAffiliation.id,10)))
          );

        // On récupère le gestionnaire affecté
        let gestionnaireAffecte = this.dossier.gestionnaires.find(gestionnaire => parseInt(gestionnaire.pivot.traitement_id) === parseInt(this.$route.query.traitementId,10))
        let notSentYet = true
        if (item.dpc) {
          notSentYet = item.dpc.sent_at === null || item.dpc.sent_at === 'null'
        } else if (this.$parent.$parent.$parent.isConformiteDBCO) {
          notSentYet = !isEmpty(item.statusPP) && item.statusPP.libelle_technique === 'a_traiter_en_cours_conformite_dbco';
        }

        // Droit lié à la personne (responsable, créateur, gestionnaire affecté)
        let isUserAuthorized = isResponsable || parseInt(user.id) === parseInt(item.collaborateurCreateurId) || (gestionnaireAffecte && parseInt(user.id) === parseInt(gestionnaireAffecte.id));
        let isValidStatus = isEnAttenteDpc || isTraitementPsAAffecter || traitementDbcoEnAttenteValidation || emailValidationIsFalse;

        // Le responsalbe, le créateur ou le gestionnaire affecté peuvent supprimer l'incident
        return (notSentYet && isUserAuthorized && isValidStatus);
    
      },
      canInitiateIncident() {
        let user = getUser()
        let treatmentAuthorized = user.profil_active[0].traitements.filter((element) => {
          return element.libelle_technique === 'qualification_courrier' || element.libelle_technique === 'ij_gestion_prestation' || element.libelle_technique === 'gestion_inval' || element.libelle_technique === 'gestion_dc' || element.libelle_technique === 'gestion_dbco'
        })
        let currentTraitement = this.$parent.$parent.$parent.allTraitements.find(treatment => treatment.id === parseInt(this.$route.query.traitementId,10));
        let mainTreatment = getMainTreatmentBasedOnType(this.dossier, this.traitements);
        // On n'autorise pas la création d'incident si on n'est pas dans le traitement principal du dossier sauf si on n'a pas de type et qu'on est en traitement qualification
        return (treatmentAuthorized.length > 0 && ((!isEmpty(mainTreatment.id) && mainTreatment.id === currentTraitement.id) || (isEmpty(mainTreatment.id) && currentTraitement && currentTraitement.libelle_technique === 'qualification_courrier')) ) || (hasRule(rules.CAN_CLOSE_ADD_INCIDENT) && currentTraitement && currentTraitement.type.toLowerCase() === 'secondaire');
      },
      canEdit(item) {
        let dpcSent = true ;
        if (!isEmpty(item.dpc)) {
          dpcSent = !isEmpty(item.dpc.sent_at);
        }
        return this.canInitiateIncident() && (parseInt(item.sousStatut) === parseInt(this.$parent.$parent.$parent.statusEnAttenteDpc.id) || parseInt(item.sousStatut) === parseInt(this.statusDpcAffiliation.id)) && parseInt(item.statut) !== 0 && dpcSent;
      },
      isResponsable() {
        return isResponsableEquipe();
      },
      // Partie DPC
      canValidateDpc() {
        return hasRule(rules.CAN_VALIDATE_DPC);
      },
      closeModal(refModal) {
        this.$refs[refModal].hide()
        this.clearErrors()
      },
      closeRelanceCourrier() {
        this.clearErrors()
        this.selecteddpcCourrierModele = ''
        this.selecteddpcMailModele = ''
        this.mailBody = '';
        this.$refs['modal-relance-courrier-dpc'].hide()
        if (this.isRelanceAnnuelle !== true) {
          this.$refs['modal-mail-dpc'].show()
        }
      },
      closeModalTypeDPC() {
        this.clearErrors()
        this.typeDpc = ''
        this.closeModal('modal-type-dpc')
      },
      closeDpcMailModal() {
        this.clearErrors()
        this.clearFormDpcMail()
        this.clearErrorsDpcmailForm()
        this.dpcContexte = 'classique';
        this.closeModal('modal-mail-dpc')
      },
      saveDpcType() {
        if (this.validateTypeDpc()) {
          let self = this
          this.closeModal('modal-type-dpc')

          let data = {}
          data.type_dpc = this.typeDpc
          data.mail_to = this.mailTo
          data.mail_subject = this.mailSubject
          data.mail_body = this.mailBody
          data.mail_cc = this.mailCc
          data.documentsNeeded = this.documentsNeeded
          data.commentaireDocBS = this.commentaireDocBS
          data.commentaireDocDecompteSS = this.commentaireDocDecompteSS
          data.periodeDateDebut = this.periodeDateDebut
          data.periodeDateFin = this.periodeDateFin
          data.arretDate = this.arretDate
          data.incident_id = this.incidentId
          data.dossier_id = this.dossier.id
          data.dpcContexte = this.dpcContexte
          data.dpcCommentaire = this.dpcCommentaire

          this.$axios
            .post('/espaceGestion/incidents/dpc/store', data)
            .then(async (response) => {
              if (this.typeDpc === 'courrier') {
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Création avec succès',
                  text: 'La DPC a bien été créée ',
                  showConfirmButton: false,
                  timer: 3000
                })
              }
              await this.getIncidents()

              if (this.typeDpc === 'mail' || this.typeDpc === 'cev') {
                for (let incident of this.incidents) {
                  if (parseInt(incident.id) === parseInt(response.data.dpc.incident_id) ) {
                    this.continueDpc(incident)
                    break
                  }
                }
              }
            })
            .catch((error) => {
              self.$store.commit('IS_LOADING', false)
                console.log(error)
                let errorText = 'Une erreur est survenue lors de la création de la DPC. Si le problème persiste, merci de faire un ticket au support DOSI.'
                self.$swal({
                position: 'top',
                type:'error',
                title:'Attention !!',
                text:errorText,
                showConfirmButton: false,
                timer: 5000
              })
            })
        }
      },
      addFileToDpc(event) {
        this.dpcAttachments = event.target.files;
      },
      clearErrorsDpcmailForm() {
        this.errors.mailTo = ""
        this.errors.selecteddpcMailModele = ""
      },
      validateDpcmailForm() {
        this.clearErrorsDpcmailForm();
        let valid = true;

        if (isEmpty(this.mailTo)) {
          valid = false;
          this.errors.mailTo = 'Vous devez saisir une adresse mail.';
        }

        if (isEmpty(this.selecteddpcMailModele)) {
          valid = false;
          this.errors.selecteddpcMailModele = 'Vous devez choisir un modèle.';
        }

        return valid;
      },
      postSendMailDpcDeces(formData, saveType) {
        let self = this
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/incidents/dpc/send', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then((response) => {
            this.$store.commit('IS_LOADING', false)
            this.manageChange()
            this.closeModal('modal-mail-dpc')

            let textSwal = saveType === 'send' && response.data.dpc_mail.is_sent ? 'Le mail a bien été envoyé' : saveType === 'send' ? 'Le mail est bien parti en validation' : 'Le mail a bien été enregistré'
            this.$swal({
              position: 'top',
              type: 'success',
              title: 'Création avec succès',
              text: textSwal,
              showConfirmButton: false,
              timer: 3000
            })
            this.clearFormDpcMail()
          })
          .catch((error) => {
            self.$store.commit('IS_LOADING', false)
            console.log(error)
            let errorText = 'Une erreur est survenue lors de l\'enregistrement/envoie du mail. Si le problème persiste, merci de faire un ticket au support DOSI.'
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            })
          })
        if (!isEmpty(this.errors.mailTo)) {
          this.errors.mailTo = ''
        }
      },
      sendMailDpcDeces(formData, saveType) {
        let self = this
        let dpcMailModele = this.incidentSelected.dpc.dpc_mails.find(dpcMail => dpcMail.selected_modele === this.selecteddpcMailModele)
        let mailModeleToCompare = this.dpcMailModeleOptions.find(mailModele => mailModele.value === this.selecteddpcMailModele)

        if(!isEmpty(dpcMailModele) && dpcMailModele.is_sent === false){
          this.postSendMailDpcDeces(formData, saveType)
        }else{
          if (isEmpty(dpcMailModele)) {
            let typeRelance = ''
            if (!isEmpty(mailModeleToCompare) && mailModeleToCompare.value == this.selecteddpcMailModele) {
              if (!isEmpty(this.incidentSelected.dpc.annual_reminder_at) && /Relance Annuelle/.test(mailModeleToCompare.text)) {
                typeRelance = 'Relance Annuelle'
              }
              if (!isEmpty(this.incidentSelected.dpc.reminder3_at) && /Relance 3/.test(mailModeleToCompare.text)) {
                typeRelance = 'Relance 3'
              }
              if (!isEmpty(this.incidentSelected.dpc.reminder2_at) && /Relance 2/.test(mailModeleToCompare.text)) {
                typeRelance = 'Relance 2'
              }
              if (!isEmpty(this.incidentSelected.dpc.reminder1_at) && /Relance 1/.test(mailModeleToCompare.text)) {
                typeRelance = 'Relance 1'
              }
            }
            if (typeRelance != '') {
              formData.append('duplicate_relance', true)
              this.$swal
                .fire({
                  title: "Êtes-vous sûr?",
                  text: "Une relance de type " + typeRelance + " a déjà été envoyé. Voulez-vous refaire une autre relance ?",
                  type: "warning",
                  reverseButtons: true,
                  showCancelButton: true,
                  allowOutsideClick: false,
                  cancelButtonColor: "#ff1744",
                  confirmButtonText: "Annuler",
                  cancelButtonText: "Valider"
                })
                .then(result => {
                  if (!result.value) {
                    this.postSendMailDpcDeces(formData, saveType)
                  }
                })
            } else {
              this.postSendMailDpcDeces(formData, saveType)
            }
          } else if (!isEmpty(dpcMailModele)) {
            let dpcMailModeleOptions = this.dpcMailModeleOptions.find(dpcMailOption => dpcMailOption.value === this.selecteddpcMailModele)
            formData.append('duplicate_relance', true)  
            this.$swal
              .fire({
                title: "Êtes-vous sûr?",
                text: "Une relance de type " + dpcMailModeleOptions.text + " a déjà été envoyé. Voulez-vous refaire une autre relance ?",
                type: "warning",
                reverseButtons: true,
                showCancelButton: true,
                allowOutsideClick: false,
                cancelButtonColor: "#ff1744",
                confirmButtonText: "Annuler",
                cancelButtonText: "Valider"
              })
              .then(result => {
                if (!result.value) {
                  this.postSendMailDpcDeces(formData, saveType)
                }
              })
          }
          else {
            this.postSendMailDpcDeces(formData, saveType)
          }
        }
      },
      saveDpcMail(saveType) {
        let canSave = false;
        let goodEmail = true;

        if (saveType === 'save') {
          if (isEmpty(this.selecteddpcMailModele) && isEmpty(this.selecteddpcCevModele)) {
            canSave = false;
            this.errors.mailTo = '';
            this.errors.selecteddpcMailModele = 'Vous devez choisir un modèle.';
            this.$swal({
                  position: 'top',
                  type:'error',
                  title:'Attention !!',
                  text: 'Vous devez choisir un modèle.',
                  showConfirmButton: false,
                  timer: 5000
                })
          } else {
            canSave = true;
          }
        }
        if ((saveType === 'send' || saveType === 'valide' || saveType === 'valideAndSend') && this.typeDpc !== 'cev') {
          if (this.validateDpcmailForm()) {
            canSave = this.mailBody.indexOf('[debut]') === -1 && this.mailBody.indexOf('[fin]') === -1 && this.mailBody.indexOf('[date]') === -1 && this.mailBody.indexOf('[remplacer]') === -1 && this.mailBody.indexOf('[prenom]') === -1 && this.mailBody.indexOf('[nom]') === -1 && this.mailBody.indexOf('[Mme/M.]') === -1 && this.mailBody.indexOf('[PRÉCÉDENT LE MOIS D’ARRÊT DE TRAVAIL]') === -1
              && this.mailBody.indexOf('[dd/MM/yyyy]') === -1 && this.mailBody.indexOf('[jour]') === -1 && this.mailBody.indexOf('[mois]') === -1 && this.mailBody.indexOf('[annee]') === -1;
            // On vérifie que l'adresse destinataire n'est pas chorum
            let chorumReg = /chorum.fr/gmi;
            let chorumEtVousReg = /chorumetvous.fr/gmi;
            if (this.mailTo.match(chorumReg) || this.mailTo.match(chorumEtVousReg)) {
              goodEmail = false;
            }
          } else {
            this.$swal({
                  position: 'top',
                  type:'error',
                  title:'Attention !!',
                  text: 'Informations nécessaires à la DPC manquantes.',
                  showConfirmButton: false,
                  timer: 5000
                })
          }
        } else if ((saveType === 'send' || saveType === 'valide' || saveType === 'valideAndSend') && this.typeDpc === 'cev') {
          if (isEmpty(this.documentsNeeded)) {
            canSave = false;
            this.$swal({
                  position: 'top',
                  type:'error',
                  title:'Attention !!',
                  text: 'Vous devez sélectionner le ou les documents attendus pour la DPC.',
                  showConfirmButton: false,
                  timer: 5000
                })
          } else {
            canSave = true;
          }
        }

        if (canSave && goodEmail) {
          // Validation type relance déjà envoyé
          let self = this
          let formData = new FormData();
          for( var i = 0; i < this.dpcAttachments.length; i++ ){
              let file = this.dpcAttachments[i];
              formData.append('files[' + i + ']', file)
          }
          formData.append('dpc_id', this.dpcId)
          formData.append('type_dpc', this.typeDpc)
          formData.append('traitement_id', this.$route.query.traitementId)
          formData.append('mail_to', this.mailTo)
          formData.append('mail_subject', this.mailSubject)
          formData.append('mail_body', this.mailBody)
          formData.append('mail_cc', this.mailCc)
          formData.append('documentsNeeded', JSON.stringify(this.documentsNeeded))
          formData.append('periodeDateDebut', this.periodeDateDebut)
          // data.commentaireDocBS = this.commentaireDocBS
          // data.commentaireDocDecompteSS = this.commentaireDocDecompteSS
          formData.append('commentaireDocBS', this.commentaireDocBS)
          formData.append('commentaireDocDecompteSS', this.commentaireDocDecompteSS)
          formData.append('periodeDateDebut', this.periodeDateDebut)
          formData.append('periodeDateFin', this.periodeDateFin)
          formData.append('arretDate', this.arretDate)
          formData.append('incident_id', this.incidentId)
          formData.append('dossier_id', this.dossier.id)
          formData.append('dpc_mail_id', this.dpcMailId)
          // formData.append('piecesJointes', JSON.stringify(this.pjRelanceDeces));
          formData.append('piecesJointes', this.pjRelanceDeces);
          if (this.incidentSelected && this.incidentSelected.dpc && this.incidentSelected.dpc.type_dpc === 'cev') {
            formData.append('selected_modele', this.selecteddpcCevModele)
          }
          else {
            formData.append('selected_modele', this.selecteddpcMailModele)
          }
          formData.append('dpcContexte', this.dpcContexte)
          formData.append('save_type', saveType)
          formData.append('dpcCommentaire', this.dpcCommentaire)

          if (!isEmpty(this.dossier.type) && this.dossier.type.groupe.toLowerCase() == 'dc') {
            this.sendMailDpcDeces(formData, saveType)
          }
          else {
            this.$store.commit('IS_LOADING', true)
            this.$axios
              .post('/espaceGestion/incidents/dpc/send', formData, {headers: {'Content-Type': 'multipart/form-data'}})
              .then((response) => {
                this.$store.commit('IS_LOADING', false)
                this.manageChange()
                this.closeModal('modal-mail-dpc')

                let textSwal = saveType === 'send' && response.data.dpc_mail.is_sent ? 'Le mail a bien été envoyé' : saveType === 'send' ? 'Le mail est bien parti en validation' : 'Le mail a bien été enregistré'
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Création avec succès',
                  text: textSwal,
                  showConfirmButton: false,
                  timer: 3000
                })
                this.clearFormDpcMail()
              })
              .catch((error) => {
                self.$store.commit('IS_LOADING', false)
                  console.log(error)
                  let errorText = 'Une erreur est survenue lors de l\'enregistrement/envoie du mail. Si le problème persiste, merci de faire un ticket au support DOSI.'
                  self.$swal({
                    position: 'top',
                    type:'error',
                    title:'Attention !!',
                    text:errorText,
                    showConfirmButton: false,
                    timer: 5000
                  })
              })
              if (!isEmpty(this.errors.mailTo)) {
                this.errors.mailTo = ''
              }
          }
        } else {
          if (this.validateDpcmailForm()) {
            let text = 'Du texte à remplacer est encore présent. Il s\'agit du texte entre crochet par exemple "[DATE]", "[DEBUT]", "[FIN]", "[NOM]", "[PRENOM]", "[Mme/M.]" ou encore "[remplacer]XXX[/remplacer]", "[PRÉCÉDENT LE MOIS D’ARRÊT DE TRAVAIL]", "[dd/MM/yyyy]", "[annee]"';
            if (!goodEmail) {
              text = 'L\'adresse mail indiquée correspond à une adresse Chorum. Veuillez indiquer l\'adresse mail du client.';
            }
            this.$swal({
              position: 'center',
              type:'warning',
              title:'Attention !!',
              text: text,
              showConfirmButton: false,
              timer: 5000
            })
          }
        }
      },
      setInfoMailAddress(dpcMailTo) {
        if (isEmpty(this.mailTo)) {
          this.mailTo = ''
          this.changeMailAddress = true
        }
        if (!isEmpty(dpcMailTo)) {
          if (dpcMailTo.endsWith('chorum.fr') || dpcMailTo.endsWith('chorumetvous.fr')) {
            this.mailTo = ''
            this.changeMailAddress = true
          } else {
            this.mailTo = dpcMailTo
            this.changeMailAddress = false
          }
        } else {
          let contactMailTo = this.getMailTo()
          if (!isEmpty(contactMailTo)) {
            if (contactMailTo.endsWith('chorum.fr') || contactMailTo.endsWith('chorumetvous.fr')) {
              this.mailTo = ''
              this.changeMailAddress = true
            } else {
              this.mailTo = contactMailTo
              this.changeMailAddress = false
            }
          }
        }
      },
      async continueReminder(incident, isRelanceAnnuelle = false){

        this.isRelance = true
        let lastMailSent = incident.dpc.dpc_mails.reduce((res, mail) => {
          if (mail.is_sent) {
            if (res === null) {
              return mail
            } else {
              return mail.created_at > res.created_at ? mail : res
            }
          }
          return res
        }, null);
        let firstMailSent = incident.dpc.dpc_mails.reduce((res, mail) => {
          if (mail.is_sent) {
            if (res === null) {
              return mail
            } else {
              return mail.created_at < res.created_at ? mail : res
            }
          }
          return res
        }, null);
   
        
        this.incidentSelected = incident;
        // console.log('incident',incident)
        // On charge les modèles s'il ne le sont pas
        // Sinon on récupère que les modèle de relance
        if (this.dpcMailModeles.length === 0 || this.dpcCevModeles.length === 0) {
          await this.getModels(incident);
        }
        this.dpcMailModeleOptions = [];
        this.dpcCevModeleOptions = [];
        this.dpcCourrierModeleOptions = [];
        let dpcModeles = [];
        if (incident.dpc.type_dpc === 'cev') {
          dpcModeles = this.dpcCevModeles
        }
        else {
          if (!isEmpty(this.dossier.type) && this.dossier.type.groupe.toLowerCase() == 'dc') {
            if (!isEmpty(incident.dpc.sent_at) && isEmpty(incident.dpc.reminder1_at)) {
              dpcModeles = this.dpcMailModeles.filter(dpcMailDc => dpcMailDc.modele.endsWith('_1'))
            }
            else if (!isEmpty(incident.dpc.sent_at) && !isEmpty(incident.dpc.reminder1_at) && isEmpty(incident.dpc.reminder2_at)) {
              dpcModeles = this.dpcMailModeles.filter(dpcMailDc => dpcMailDc.modele.endsWith('_1') || dpcMailDc.modele.endsWith('_2'))
            }
            else if (!isEmpty(incident.dpc.sent_at) && !isEmpty(incident.dpc.reminder1_at) && !isEmpty(incident.dpc.reminder2_at) && isEmpty(incident.dpc.reminder3_at)) {
              dpcModeles = this.dpcMailModeles.filter(dpcMailDc => dpcMailDc.modele.endsWith('_1') || dpcMailDc.modele.endsWith('_2') || dpcMailDc.modele.endsWith('_3'))
            }
            else if (!isEmpty(incident.dpc.sent_at) && !isEmpty(incident.dpc.reminder1_at) && !isEmpty(incident.dpc.reminder2_at) && !isEmpty(incident.dpc.reminder3_at) && isEmpty(incident.dpc.annual_reminder_at)) {
              dpcModeles = this.dpcMailModeles.filter(dpcMailDc => dpcMailDc.modele.endsWith('_1') || dpcMailDc.modele.endsWith('_2') || dpcMailDc.modele.endsWith('_3') || dpcMailDc.modele.endsWith('_an'))
            }
            else {
              dpcModeles = this.dpcMailModeles.filter(dpcMailDc => dpcMailDc.modele.endsWith('_1') || dpcMailDc.modele.endsWith('_2') || dpcMailDc.modele.endsWith('_3') || dpcMailDc.modele.endsWith('_an'))
            }
          }
          else {
            dpcModeles = this.dpcMailModeles
          }
        }
        
        for (let dpcMail of incident.dpc.dpc_mails) {
          if (dpcMail.is_sent === false) {
            this.incidentSelected = incident
            if (incident.dpc.type_dpc === 'cev') {
            	this.selecteddpcCevModele = dpcMail.selected_modele
            }
            else {
            	this.selecteddpcMailModele = dpcMail.selected_modele
            }

            let subject = dpcMail.subject
            if (! subject) {
              subject = this.getMailSubject()
            }

            this.setInfoMailAddress(dpcMail.to)
            this.mailSubject = subject
            this.mailBody = dpcMail.body
            this.mailCc = dpcMail.cc === 'null' ? '' : dpcMail.cc
            this.mailTo = dpcMail.to === 'null' ? '' : dpcMail.to
            this.documentsNeeded = dpcMail.dpc_type_documents //.map(doc => { return doc.id })
            let decompteSS = dpcMail.dpc_type_documents.filter(dpcTypeDocument => dpcTypeDocument.libelle_technique === 'decomptes_ss')
            this.commentaireDocDecompteSS = !isEmpty(decompteSS[0]) ? decompteSS[0].pivot.commentaire : ''
            let bulletinsSalaire = dpcMail.dpc_type_documents.filter(dpcTypeDocument => dpcTypeDocument.libelle_technique === 'bulletins_salaire')
            this.commentaireDocBS = !isEmpty(bulletinsSalaire[0]) ? bulletinsSalaire[0].pivot.commentaire : ''
            this.periodeDateDebut = dpcMail.date_debut_periode ? dpcMail.date_debut_periode : typeof this.dossier.date_debut_periode === 'object' && this.dossier.date_debut_periode !== null && this.dossier.date_debut_periode.isValid() ? this.dossier.date_debut_periode : ''
            this.periodeDateFin = dpcMail.date_fin_periode ? dpcMail.date_fin_periode : typeof this.dossier.date_fin_periode === 'object' && this.dossier.date_fin_periode !== null && this.dossier.date_fin_periode.isValid() ? this.dossier.date_fin_periode : ''
            this.arretDate = dpcMail.date_arret === 'null' ? '' : dpcMail.date_arret
            this.incidentId = incident.id
            this.dpcMailId = dpcMail.id
            this.dpcMailToContinue = dpcMail
            this.dpcAttachmentsUploaded = dpcMail.pieces_jointes
            this.pjRelanceDeces = dpcMail.pieces_jointes_liees.map(item => item.id)
            // console.log('this.pjRelanceDeces',this.pjRelanceDeces)
            this.typeDpc = incident.dpc.type_dpc
            this.dpcId = incident.dpc.id
            this.dpcContexte = incident.dpc.contexte
            this.dpcCommentaire = !isEmpty(incident.dpc.commentaire) && incident.dpc.commentaire !== 'null' ? incident.dpc.commentaire : ''
          }
        }

        if (isRelanceAnnuelle === true) {
          this.isRelanceAnnuelle = true
          this.incidentSelected = incident;
          for (let modele of dpcModeles) {
            if (!isEmpty(this.dossier.type) && this.dossier.type.groupe.toLowerCase() == 'dc') {
              if (modele.modele.indexOf('_an') > -1 && modele.type_model.indexOf('relance') > -1) {
                this.dpcCourrierModeleOptions.push({ value: modele.id, text: modele.libelle });
              }
            }
          }
          this.showRelanceCourrier()
        }
        else {
          this.isRelanceAnnuelle = false
          for (let modele of dpcModeles) {
            if (!isEmpty(this.dossier.type) && this.dossier.type.groupe.toLowerCase() == 'dc') {
              if (modele.modele.indexOf('dc') > -1 && modele.type_model.indexOf('relance') > -1) {
                this.dpcMailModeleOptions.push({ value: modele.id, text: modele.libelle });
                this.dpcCourrierModeleOptions.push({ value: modele.id, text: modele.libelle });
              }
            } else {
              if (modele.modele[0] === 'R' || modele.modele[0] === 'C') {
                if (incident.dpc.type_dpc === 'cev') {
                  this.dpcCevModeleOptions.push({ value: modele.id, text: modele.libelle });
                }
                else {
                  this.dpcMailModeleOptions.push({ value: modele.id, text: modele.libelle });
                  this.dpcCourrierModeleOptions.push({ value: modele.id, text: modele.libelle });
                }
              }
            }
          }
          if (!isEmpty(this.dossier.type) && this.dossier.type.groupe.toLowerCase() == 'dc') {
            this.dpcMailModeleOptions.push({ value: 'courrier', text: 'Relance Courrier' });
          }
          this.$refs['modal-mail-dpc'].show();
        }
        this.dpcId = incident.dpc.id;
        this.setInfoMailAddress(lastMailSent.to)

      },
      async continueDpc(incident) {
          this.isRelance = false
        /*if(incident.dpc.dpc_mails.dpc_mail_model.type_modele==='dpc'){
          this.isRelance = false
        }*/
        if (this.dpcMailModeles.length === 0 && this.dpcCevModeles.length === 0) {
          await this.getModels(incident);
        }
        this.getDpcMailModele(incident);

        for (let dpcMail of incident.dpc.dpc_mails) {
          if (dpcMail.is_sent === false) {
            this.incidentSelected = incident
            if (incident.dpc.type_dpc === 'cev') {
            	this.selecteddpcCevModele = dpcMail.selected_modele
            }
            else {
            	this.selecteddpcMailModele = dpcMail.selected_modele
            }

            let subject = dpcMail.subject
            if (! subject) {
              subject = this.getMailSubject()
            }

            this.setInfoMailAddress(dpcMail.to)
            this.mailSubject = subject
            this.mailBody = dpcMail.body
            this.mailCc = dpcMail.cc === 'null' ? '' : dpcMail.cc
            this.documentsNeeded = dpcMail.dpc_type_documents //.map(doc => { return doc.id })
            let decompteSS = dpcMail.dpc_type_documents.filter(dpcTypeDocument => dpcTypeDocument.libelle_technique === 'decomptes_ss')
            this.commentaireDocDecompteSS = !isEmpty(decompteSS[0]) ? decompteSS[0].pivot.commentaire : ''
            let bulletinsSalaire = dpcMail.dpc_type_documents.filter(dpcTypeDocument => dpcTypeDocument.libelle_technique === 'bulletins_salaire')
            this.commentaireDocBS = !isEmpty(bulletinsSalaire[0]) ? bulletinsSalaire[0].pivot.commentaire : ''
            this.periodeDateDebut = dpcMail.date_debut_periode ? dpcMail.date_debut_periode : typeof this.dossier.date_debut_periode === 'object' && this.dossier.date_debut_periode !== null && this.dossier.date_debut_periode.isValid() ? this.dossier.date_debut_periode : ''
            this.periodeDateFin = dpcMail.date_fin_periode ? dpcMail.date_fin_periode : typeof this.dossier.date_fin_periode === 'object' && this.dossier.date_fin_periode !== null && this.dossier.date_fin_periode.isValid() ? this.dossier.date_fin_periode : ''
            this.arretDate = dpcMail.date_arret === 'null' ? '' : dpcMail.date_arret
            this.incidentId = incident.id
            this.dpcMailId = dpcMail.id
            this.dpcMailToContinue = dpcMail
            this.dpcAttachmentsUploaded = dpcMail.pieces_jointes
            this.typeDpc = incident.dpc.type_dpc
            this.dpcId = incident.dpc.id
            this.dpcContexte = incident.dpc.contexte
            this.dpcCommentaire = !isEmpty(incident.dpc.commentaire) && incident.dpc.commentaire !== 'null' ? incident.dpc.commentaire : ''
          }
        }
        this.$refs['modal-mail-dpc'].show()
      },
      getNl2br(commentaire) {
        // console.log(commentaire);
        return nl2br(commentaire);
      },
      getMailSubject() {
        let subject = ''
        if(this.dossier.nom && this.dossier.type) {
          subject = 'DPC-' + this.dossier.type.code + '/' + this.dossier.nom.toUpperCase() + ' ' + this.dossier.prenom + '   ' + this.getIdRetourDpc()
        } else {
          subject = 'Demande de pièces complémentaires  ' + this.getIdRetourDpc()
        }
        return subject
      },
      deleteDpcPj(pj, type) {
        this.$swal
          .fire({
            title: "Êtes-vous sûr?",
            text: "Voulez-vous vraiment supprimer cette pièce jointe ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            allowOutsideClick: false,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Annuler",
            cancelButtonText: "Supprimer"
          })
          .then(result => {
            if (!result.value) {
              let self = this;
              let data = {};
              data.traitementId = this.$route.query.traitementId;
              data.type = !isEmpty(type) ? type : '';
              data.incident_id = this.incidentSelected.id;

              this.$store.commit("IS_LOADING", true);

              this.$axios
                .post("/espaceGestion/dossier-pieces-jointes/delete/"+pj.id,data)
                .then(response => {
                  this.$store.commit("IS_LOADING", false);
                  if (type === 'dbco') {
                    this.mailDbcoPiecesJointes = this.mailDbcoPiecesJointes.filter(pjUploaded => pj.id !== pjUploaded.id);
                  } else {
                    this.dpcAttachmentsUploaded = this.dpcAttachmentsUploaded.filter(pjUploaded => pj.id !== pjUploaded.id);
                  }

                  this.manageChange()
                  this.$swal(
                    {
                      position: 'top',
                      type: 'success',
                      title: 'Suppression',
                      text: 'La pièce jointe a été correctement supprimée.',
                      showConfirmButton: false,
                      timer: 5000
                    })
                })
                .catch(function(error) {
                  self.$store.commit("IS_LOADING", false);
                  self.$swal({
                    position: "top",
                    type: "error",
                    title: "Attention !!",
                    text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                    showConfirmButton: false,
                    timer: 5000
                  })
                })
            }
          })
      },
      downloadDpcPj(pj) {
        let fileNameArr = pj.name.split('.')
        let ext = fileNameArr.pop();
        let name = fileNameArr.join('.');
        this.$axios
          .get("/espaceGestion/dossier-pieces-jointes/download/"+pj.id, {responseType: 'arraybuffer'})
          .then(response => {
            downloadFile(response, name, ext);
          })
          .catch(() => {
            this.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 4000
            });
          })
      },
      downloadMailPj(pjId) {
        let pj = this.pieces_jointes.find(pj => pj.id === pjId)
        if (!isEmpty(pj)) {
          let fileNameArr = pj.name.split('.')
          let ext = fileNameArr.pop();
          let name = fileNameArr.join('.');
          this.$axios
            .get("/espaceGestion/dossier-pieces-jointes/download/"+pj.id, {responseType: 'arraybuffer'})
            .then(response => {
              downloadFile(response, name, ext);
            })
            .catch(() => {
              this.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 4000
              });
            })
        }
      },
      getModels(incident) {
        return new Promise(resolve => {
          let self = this
          let url = incident.dpc && incident.dpc.type_dpc === 'cev' ? '/espaceGestion/incidents/dpc/getModelsCev' : '/espaceGestion/incidents/dpc/getModels';
          this.$axios
            .get(url)
            .then(response => {
              if (incident.dpc && incident.dpc.type_dpc === 'cev') {
                this.dpcCevModeles = response.data.modeles;
              } else {
                this.dpcMailModeles = response.data.modeles;
              }
              resolve();
            })
            .catch((error) => {
              // self.$store.commit('IS_LOADING', false)
              console.log(error)
              let errorText = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.'
              self.$swal({
                position: 'top',
                type:'error',
                title:'Attention !!',
                text:errorText,
                showConfirmButton: false,
                timer: 5000
              })
              resolve();
            })
        });
      },
      getDpcMailModele(incident) {
        this.dpcMailModeleOptions = [];
        this.dpcCevModeleOptions = [];
        let alreadySendDpc = false
        for (let mail of incident.dpc.dpc_mails) {
          if (mail.is_sent) { alreadySendDpc = true }
        }
        if (incident.dpc.type_dpc !== 'cev') {
          for (let modele of this.dpcMailModeles) {
            if (!this.dossier.type) {
              // Cas de la QC où le type de dossier n'est pas forcément présent, on prend par defaut "ij" qui est le plus complet
              if (!alreadySendDpc && modele.modele.indexOf('ij') > -1) {
                if (modele.type_model.indexOf('relance') === -1) {
                  this.dpcMailModeleOptions.push({value: modele.id, text: modele.libelle})
                }
              } else if (alreadySendDpc && modele.modele.indexOf('ij') === -1 && modele.modele.indexOf('inval') === -1 && modele.modele.indexOf('dc') === -1) {
                this.dpcMailModeleOptions.push({value: modele.id, text: modele.libelle})
              }
            } else {
              if (!alreadySendDpc && modele.modele.indexOf(this.dossier.type.groupe.toLowerCase()) > -1) {
                if (modele.type_model.indexOf('relance') === -1) {
                  this.dpcMailModeleOptions.push({value: modele.id, text: modele.libelle})
                }
              } else if (alreadySendDpc && modele.modele.indexOf('ij') === -1 && modele.modele.indexOf('inval') === -1 && modele.modele.indexOf('dc') === -1) {
                this.dpcMailModeleOptions.push({value: modele.id, text: modele.libelle})
              }
            }
          }
        } else {
          for (let modele of this.dpcCevModeles) {
            if (!this.dossier.type) {
              // Cas de la QC où le type de dossier n'est pas forcément présent, on prend par defaut "ij"
              if (!alreadySendDpc && modele.modele.indexOf('ij') > -1) {
                this.dpcCevModeleOptions.push({value: modele.id, text: modele.libelle})
              } else if (alreadySendDpc && modele.modele.indexOf('ij') === -1 && modele.modele.indexOf('inval') === -1 && modele.modele.indexOf('dc') === -1) {
                this.dpcCevModeleOptions.push({value: modele.id, text: modele.libelle})
              }
            } else {
              if (!alreadySendDpc && modele.modele.indexOf(this.dossier.type.groupe.toLowerCase()) > -1) {
                this.dpcCevModeleOptions.push({value: modele.id, text: modele.libelle})
              } else if (alreadySendDpc && modele.modele.indexOf('ij') === -1 && modele.modele.indexOf('inval') === -1 && modele.modele.indexOf('dc') === -1) {
                this.dpcCevModeleOptions.push({value: modele.id, text: modele.libelle})
              }
            }
          }
        }
      },
      getDpcDocuments() {
        let self = this
        this.$axios
          .get("/espaceGestion/incidents/dpc/getDocuments")
          .then(response => {
            this.dpcDocuments = response.data.documents
          })
          .catch((error) => {
              // self.$store.commit('IS_LOADING', false)
                console.log(error)
                let errorText = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.'
                self.$swal({
                  position: 'top',
                  type:'error',
                  title:'Attention !!',
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                })
            })
      },
      getIdRetourDpc() {
        return 'ref : [' + this.dateTimeToString(this.dossier.date_reception) + '-' + this.dossier.id + '-DPC-' + this.incidentSelected.id + ']';
      },
      showRelanceCourrier(){
        this.$refs['modal-relance-courrier-dpc'].show();
        this.$refs['modal-mail-dpc'].hide();
      },
      manageModelDpc() {
        let modele = {}

        if(this.selecteddpcMailModele === 'courrier'){
          this.showRelanceCourrier();
          return true;
        }
        if (this.incidentSelected && this.incidentSelected.dpc && this.incidentSelected.dpc.type_dpc === 'cev') {
          modele = this.dpcCevModeles.reduce((res, modele) => {
            return parseInt(modele.id,10) === parseInt(this.selecteddpcCevModele,10) ? modele : res
          },{})
        }
        else {
          modele = this.dpcMailModeles.reduce((res, modele) => {
            return parseInt(modele.id,10) === parseInt(this.selecteddpcMailModele,10) ? modele : res
          },{})
        }

        let modeleMailDeces = modele.message
        let firstMailSent = {body: ''}

        if (this.incidentSelected !== null) {
          firstMailSent = this.incidentSelected.dpc.dpc_mails.reduce((res, mail) => {
            if (mail.is_sent) {
              if (res === null) {
                return mail
              } else {
                return mail.created_at < res.created_at ? mail : res
              }
            }
            return res
          },null)

          if (this.incidentSelected.dpc !== null) {
            this.documentsInMessage = '<ul>'
            for (let doc of this.incidentSelected.dpc.dpc_mails[0].dpc_type_documents) {
              this.documentsInMessage = this.documentsInMessage + '<li>' + doc.libelle_court + '</li>'
            }
            this.documentsInMessage = this.documentsInMessage + '</ul>'
          }
        }

        this.mailBody = modele.message

        let regexIdRetour = /\[idRetour\]/i
        let regexPrenom = /\[prenom\]/i
        let regexNom = /\[nom\]/i
        let regexDateDpc = /\[dd\/MM\/yyyy\]/i
        let regexCivilite = /\[Mme\/M.\]/i
        let regexAnneeReversement = /\[annee\]/i
        if (this.incidentSelected && this.incidentSelected.dpc && this.incidentSelected.dpc.type_dpc === 'cev') {
          this.mailBody = this.mailBody.replace(regexIdRetour, this.getIdRetourDpc()).replace(regexPrenom, this.dossier.prenom).replace(regexNom, this.dossier.nom);
        }
        else {
          this.mailBody = this.mailBody.replace(regexIdRetour, this.getIdRetourDpc())
        }

        if (modele.modele[0] !== 'C' && modele.modele[0] !== 'R' && modele.modele[0] !== 'dc_r_') {
          if (this.dossier.mail) {
            this.mailBody = this.mailBody + '<br><br> ---------------- Votre mail version texte ---------------<br><br>' + nl2br(this.dossier.mail.body_text) + '<br><br> ---------------- Votre mail version html ---------------<br><br>' + this.dossier.mail.body_html;
          }
        }

        if (modele.modele === 'ij_4' || modele.modele === 'ij_5') {
          this.getDpcDocuments()
          this.$refs['modal-document-dpc'].show()
        } else if (modele.modele[0] === 'C' || modele.modele[0] === 'R') {
          this.mailSubject = modele.modele[0] === 'C' ? 'Renvoi ' + this.getMailSubject() : 'Relance ' + this.getMailSubject()
          this.mailBody = this.mailBody + '<br><br><b>Précédent mail : </b><br>' + nl2br(firstMailSent.body)
        } else if(modele.modele.substring(0, 5) === 'dc_r_') {
          this.mailSubject = 'Relance ' + this.getMailSubject()
          let dateDpc = this.formatDate(this.incidentSelected.dpc.sent_at)
          let nir = this.dossier.nir ? this.dossier.nir : ''
          let civilite = 'Mme/M.'
          if (!isEmpty(nir)) {
            civilite = nir.substring(0, 1) == 1 ? 'M.' : 'Mme'
          }

          let dateDeces = this.dossier.fiche_deces.date_deces
          if (dateDeces === null) {
            dateDeces = this.dossier.fiche_deces.date_information_deces
          }
          if (!isEmpty(dateDeces)) {
            let anneeDeces = new Date(dateDeces).getFullYear()
            let anneeReversement = anneeDeces + 10
            this.mailBody = modeleMailDeces.replace(regexIdRetour, this.getIdRetourDpc()).replace(regexPrenom, this.dossier.prenom).replace(regexNom, this.dossier.nom).replace(regexDateDpc, dateDpc)
              .replace(regexCivilite, civilite).replace(regexAnneeReversement, anneeReversement) + '<br><br><b>Précédent mail : </b><br>' + nl2br(firstMailSent.body)
          } else {
            this.mailBody = modeleMailDeces.replace(regexIdRetour, this.getIdRetourDpc()).replace(regexPrenom, this.dossier.prenom).replace(regexNom, this.dossier.nom).replace(regexDateDpc, dateDpc)
              .replace(regexCivilite, civilite) + '<br><br><b>Précédent mail : </b><br>' + nl2br(firstMailSent.body)
          }
        }
      },
      cancelCheck() {
        this.$refs['modal-document-dpc'].hide()
      },
      checkDocuments() {
        this.clearErrors()
        if (this.validateDocumentData()) {
          this.closeModal('modal-document-dpc')
          let regexDebut = /\[debut\]/i
          let regexFin = /\[fin\]/i
          let regexDate = /\[date\]/i
          let regexDocument = /\[documents\]/i
          let regexIdRetour = /\[idRetour\]/i
          let regexPrenom = /\[prenom\]/i
          let regexNom = /\[nom\]/i

          this.documentsInMessage = '<ul>'
          for (let doc of this.documentsNeeded) {
            this.documentsInMessage = this.documentsInMessage + '<li>' + doc.libelle_long + '</li>'
          }
          this.documentsInMessage = this.documentsInMessage + '</ul>'

          if (this.incidentSelected && this.incidentSelected.dpc && this.incidentSelected.dpc.type_dpc === 'cev') {
            this.mailBody = this.mailBody.replace(regexPrenom, this.dossier.prenom).replace(regexNom, this.dossier.nom)
          }
          else {
            this.mailBody = this.mailBody.replace(regexDocument, this.documentsInMessage).replace(regexIdRetour, this.getIdRetourDpc())
          }
        } else {
          this.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Vous devez sélectionner le ou les documents attendus pour la DPC.',
              showConfirmButton: false,
              timer: 5000
            });
        }
      },
      uploadCourrier(item, type) {
        if (type === 'dpc') {
          this.dpcId = item.dpc.id;
          this.typeUpload = 'dpc';
        } else if (type === 'dbco') {

          this.typeUpload = 'dbco';
        }
        this.selectedIncident = item;
        this.$refs['modal-chargement-courrier'].show()
      },
      addFile(event) {
        this.attachment = event.target.files[0]
      },
      postRelanceCourrier(formData, url) {
        this.$axios
        .post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}})
        .then(() => {
          this.$swal({
            position: 'top',
            type: 'success',
            title: 'Enregistrement avec succès',
            text: 'Le fichier a bien été envoyé',
            showConfirmButton: false,
            timer: 4000
          });
          this.manageChange();
          this.closeModal('modal-relance-courrier-dpc');
          this.attachment = '';
          this.dpcId = '';
          this.typeUpload = '';
          this.selectedIncident = {};
          this.clearErrors();
          this.selecteddpcCourrierModele = '';
          this.dpcCourrierDateRelance = '';
        })
        .catch(() => {
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue lors de l\'envoi du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',
            showConfirmButton: false,
            timer: 5000
          });
        })
        .finally(() => self.$store.commit('IS_LOADING', false));
      },
      saveRelanceCourrier() {
        if (isEmpty(this.selecteddpcCourrierModele)) {
          this.errors.mailTo = '';
          this.errors.selecteddpcCourrierModele = 'Vous devez choisir un modèle.';
          this.$swal({
            position: 'top',
            type:'error',
            title:'Attention !!',
            text: 'Vous devez choisir un modèle.',
            showConfirmButton: false,
            timer: 5000
          })
        }

        let self = this;
        if (this.validateRelanceCourrier()) {
          let url = '/espaceGestion/incidents/dpc/saveRelanceCourrier';
          let formData = new FormData();
          formData.append('file', this.attachment);
          formData.append('dossier_id', this.dossier.id);
          formData.append('incident_id', this.selectedIncident.id);
          formData.append('dpc_id', this.dpcId);
          formData.append('traitement_id', this.$route.query.traitementId);
          formData.append('typeUpload', 'dpc');
          formData.append('selected_modele', this.selecteddpcCourrierModele)
          formData.append('date_relance', this.dpcCourrierDateRelance);
          formData.append('dpc_mail_id', this.dpcMailId)
          // Validation type relance déjà envoyé

          let dpcCourrierModele = this.incidentSelected.dpc.dpc_mails.find(dpcMail => dpcMail.selected_modele === this.selecteddpcCourrierModele)
          let courrierModeleToCompare = this.dpcCourrierModeleOptions.find(courrierModele => courrierModele.value === this.selecteddpcCourrierModele)

          if (isEmpty(dpcCourrierModele)) {
            let typeRelance = ''
            if (!isEmpty(courrierModeleToCompare) && courrierModeleToCompare.value == this.selecteddpcCourrierModele) {
              if (!isEmpty(this.incidentSelected.dpc.annual_reminder_at) && /Relance Annuelle/.test(courrierModeleToCompare.text)) {
                typeRelance = 'Relance Annuelle'
              }
              if (!isEmpty(this.incidentSelected.dpc.reminder3_at) && /Relance 3/.test(courrierModeleToCompare.text)) {
                typeRelance = 'Relance 3'
              }
              if (!isEmpty(this.incidentSelected.dpc.reminder2_at) && /Relance 2/.test(courrierModeleToCompare.text)) {
                typeRelance = 'Relance 2'
              }
              if (!isEmpty(this.incidentSelected.dpc.reminder1_at) && /Relance 1/.test(courrierModeleToCompare.text)) {
                typeRelance = 'Relance 1'
              }
            }
            if (typeRelance != '') {
              formData.append('duplicate_relance', true)
              this.$swal
                .fire({
                  title: "Êtes-vous sûr?",
                  text: "Une relance de type " + typeRelance + " a déjà été envoyé. Voulez-vous refaire une autre relance ?",
                  type: "warning",
                  reverseButtons: true,
                  showCancelButton: true,
                  allowOutsideClick: false,
                  cancelButtonColor: "#ff1744",
                  confirmButtonText: "Annuler",
                  cancelButtonText: "Valider"
                })
                .then(result => {
                  if (!result.value) {
                    this.postRelanceCourrier(formData, url)
                  }
                })
            } else {
              this.postRelanceCourrier(formData, url)
            }
          }
          else {
            let dpcCourrierModeleOptions = this.dpcCourrierModeleOptions.find(dpcCourrierOption => dpcCourrierOption.value === this.selecteddpcCourrierModele)
            formData.append('duplicate_relance', true)
            this.$swal
              .fire({
                title: "Êtes-vous sûr?",
                text: "Une relance de type " + dpcCourrierModeleOptions.text + " a déjà été envoyé. Voulez-vous refaire une autre relance ?",
                type: "warning",
                reverseButtons: true,
                showCancelButton: true,
                allowOutsideClick: false,
                cancelButtonColor: "#ff1744",
                confirmButtonText: "Annuler",
                cancelButtonText: "Valider"
              })
              .then(result => {
                if (!result.value) {
                  this.postRelanceCourrier(formData, url)
                }
              })
          }
        }
      },
      saveFile() {
        let self = this;
        if (this.validateSaveFile()) {
          let url = this.typeUpload === 'dpc' ? '/espaceGestion/incidents/dpc/upload' : (this.typeUpload === 'dbco' ? '/espaceGestion/incidents/dbco/upload' : '')
          let formData = new FormData();
          formData.append('date_relance', this.dpcCourrierDateRelance);
          formData.append('file', this.attachment);
          formData.append('dossier_id', this.dossier.id);
          formData.append('incident_id', this.selectedIncident.id);
          formData.append('dpc_id', this.dpcId);
          formData.append('traitement_id', this.$route.query.traitementId);
          formData.append('typeUpload', this.typeUpload);
          this.$axios
            .post(url,
              formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(() => {
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Création avec succès',
                text: 'Le fichier a bien été envoyé',
                showConfirmButton: false,
                timer: 4000
              });
              this.manageChange();
              this.closeModal('modal-chargement-courrier');
              this.attachment = '';
              this.dpcId = '';
              this.typeUpload = '';
              this.selectedIncident = {};
              this.clearErrors();
            })
            .catch(() => {
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue lors de l\'envoi du fichier. Si le problème persiste, merci de faire un ticket au support DOSI.',
                showConfirmButton: false,
                timer: 5000
              });
            })
            .finally(() => self.$store.commit('IS_LOADING', false));
        }
      },
      validateRelanceCourrier(){
        let valid = true
        this.errors.selecteddpcCourrierModele = '';
        this.errors.dpcCourrierDateRelance = '';

        let today = new Date();
        let dateSaisie = new Date(this.dpcCourrierDateRelance);

        if(!this.validateSaveFile()){
          valid = false;
        }

        if (isEmpty(this.dpcCourrierDateRelance)) {
          valid = false;
          this.errors.dpcCourrierDateRelance = 'Vous devez saisir une date.';
        }else if(dateSaisie > today.getTime()){
          valid = false;
          this.errors.dpcCourrierDateRelance = 'Vous ne pouvez pas saisir une date future.';
        }

        if (isEmpty(this.selecteddpcCourrierModele)) {
          valid = false;
          this.errors.selecteddpcCourrierModele = 'Vous devez choisir un modèle.';
        }

        return valid
      },
      validateSaveFile() {
        let valid = true

        if (this.attachment === '') {
          valid = false
          this.errors.attachment = 'Vous devez choisir un fichier'
        }

        return valid
      },
      validateTypeDpc() {
        let valid = true

        if (this.typeDpc === '') {
          valid = false
          this.errors.typeDpc = 'Vous devez choisir un type de DPC'
        }

        return valid
      },
      validateDocumentData() {
        let valid = true
        if (this.documentsNeeded.length === 0) {
          valid = false
          this.errors.documentsNeeded = 'Vous devez choisir au moins un type de document.'
        }
        return valid
      },
      manageChange() {
        this.getIncidents()
        // this.$parent.getDossier()
        this.$event.emit('refreshDossier')
      },
      async doReminder(incident, isRelanceAnnuelle) {
        this.isRelance = true
        let lastMailSent = incident.dpc.dpc_mails.reduce((res, mail) => {
          if (mail.is_sent) {
            if (res === null) {
              return mail
            } else {
              return mail.created_at > res.created_at ? mail : res
            }
          }
          return res
        }, null);
        let firstMailSent = incident.dpc.dpc_mails.reduce((res, mail) => {
          if (mail.is_sent) {
            if (res === null) {
              return mail
            } else {
              return mail.created_at < res.created_at ? mail : res
            }
          }
          return res
        }, null);
        this.clearFormDpcMail();
        this.incidentSelected = incident;
        // On charge les modèles s'il ne le sont pas
        // Sinon on récupère que les modèle de relance
        if (this.dpcMailModeles.length === 0 || this.dpcCevModeles.length === 0) {
          await this.getModels(incident);
        }
        this.dpcMailModeleOptions = [];
        this.dpcCevModeleOptions = [];
        this.dpcCourrierModeleOptions = [];
        let dpcModeles = [];
        if (incident.dpc.type_dpc === 'cev') {
          dpcModeles = this.dpcCevModeles
        }
        else {
          if (!isEmpty(this.dossier.type) && this.dossier.type.groupe.toLowerCase() == 'dc') {
            if (!isEmpty(incident.dpc.sent_at) && isEmpty(incident.dpc.reminder1_at)) {
              dpcModeles = this.dpcMailModeles.filter(dpcMailDc => dpcMailDc.modele.endsWith('_1'))
            }
            else if (!isEmpty(incident.dpc.sent_at) && !isEmpty(incident.dpc.reminder1_at) && isEmpty(incident.dpc.reminder2_at)) {
              dpcModeles = this.dpcMailModeles.filter(dpcMailDc => dpcMailDc.modele.endsWith('_1') || dpcMailDc.modele.endsWith('_2'))
            }
            else if (!isEmpty(incident.dpc.sent_at) && !isEmpty(incident.dpc.reminder1_at) && !isEmpty(incident.dpc.reminder2_at) && isEmpty(incident.dpc.reminder3_at)) {
              dpcModeles = this.dpcMailModeles.filter(dpcMailDc => dpcMailDc.modele.endsWith('_1') || dpcMailDc.modele.endsWith('_2') || dpcMailDc.modele.endsWith('_3'))
            }
            else if (!isEmpty(incident.dpc.sent_at) && !isEmpty(incident.dpc.reminder1_at) && !isEmpty(incident.dpc.reminder2_at) && !isEmpty(incident.dpc.reminder3_at) && isEmpty(incident.dpc.annual_reminder_at)) {
              dpcModeles = this.dpcMailModeles.filter(dpcMailDc => dpcMailDc.modele.endsWith('_1') || dpcMailDc.modele.endsWith('_2') || dpcMailDc.modele.endsWith('_3') || dpcMailDc.modele.endsWith('_an'))
            }
            else {
              dpcModeles = this.dpcMailModeles.filter(dpcMailDc => dpcMailDc.modele.endsWith('_1') || dpcMailDc.modele.endsWith('_2') || dpcMailDc.modele.endsWith('_3') || dpcMailDc.modele.endsWith('_an'))
            }
          }
          else {
            dpcModeles = this.dpcMailModeles
          }
        }

        if (isRelanceAnnuelle === true) {
          this.isRelanceAnnuelle = true
          this.incidentSelected = incident;
          for (let modele of dpcModeles) {
            if (!isEmpty(this.dossier.type) && this.dossier.type.groupe.toLowerCase() == 'dc') {
              if (modele.modele.indexOf('_an') > -1 && modele.type_model.indexOf('relance') > -1) {
                this.dpcCourrierModeleOptions.push({ value: modele.id, text: modele.libelle });
              }
            }
          }
          this.showRelanceCourrier()
        }
        else {
          this.isRelanceAnnuelle = false
          for (let modele of dpcModeles) {
            if (!isEmpty(this.dossier.type) && this.dossier.type.groupe.toLowerCase() == 'dc') {
              if (modele.modele.indexOf('dc') > -1 && modele.type_model.indexOf('relance') > -1) {
                this.dpcMailModeleOptions.push({ value: modele.id, text: modele.libelle });
                this.dpcCourrierModeleOptions.push({ value: modele.id, text: modele.libelle });
              }
            } else {
              if (modele.modele[0] === 'R' || modele.modele[0] === 'C') {
                if (incident.dpc.type_dpc === 'cev') {
                  this.dpcCevModeleOptions.push({ value: modele.id, text: modele.libelle });
                }
                else {
                  this.dpcMailModeleOptions.push({ value: modele.id, text: modele.libelle });
                  this.dpcCourrierModeleOptions.push({ value: modele.id, text: modele.libelle });
                }
              }
            }
          }
          if (!isEmpty(this.dossier.type) && this.dossier.type.groupe.toLowerCase() == 'dc') {
            this.dpcMailModeleOptions.push({ value: 'courrier', text: 'Relance Courrier' });
          }
          this.$refs['modal-mail-dpc'].show();
        }
        this.dpcId = incident.dpc.id;
        this.setInfoMailAddress(lastMailSent.to)
      },
      viewSentMail(incident) {
        let mails = incident.dpc.dpc_mails.filter( mail => {
          return mail.is_sent || mail.wait_for_validation;
        })
        mails.sort((a,b) => {
          if (a.created_at > b.created_at) {
            return -1
          } else if (a.created_at < b.created_at) {
            return 1
          }
          return 0
        })

        this.alreadySentMails = mails
        this.incidentSelected = incident
        this.dpcCommentaire = incident.dpc.commentaire
        this.$refs['modal-mail-sent-dpc'].show()
      },
      closeViewSentMailModal() {
        this.alreadySentMails = []
        this.$refs['modal-mail-sent-dpc'].hide()
      },
      getBackToDpc(incident) {
        this.$swal.fire({
          title: 'Êtes-vous sûr?',
          text: 'Voulez-vous vraiment repasser cet incident à "En attente DPC" ?',
          type: 'warning',
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonColor:"#ff1744",
          confirmButtonText: 'Annuler',
          cancelButtonText: 'passer à "En attente DPC"',
        }).then((result) => {
          if (result.value !== true) {
            let self = this;
            let sousStatusId = this.$parent.$parent.$parent.statusEnAttenteDpc.id;
            if (!isEmpty(incident.dpc) && incident.dpc.contexte === 'affiliation') {
              let statusDpcAffiliation = this.$parent.$parent.$parent.statusEnAttente.sous_statuts.find(status => status.libelle_technique === 'en_attente_dpc_affiliation');
              sousStatusId = statusDpcAffiliation.id;
            }
            let data = {
              'dossier_id': this.dossier.id,
              'sous_status_id': sousStatusId,
              'traitement_pp_id': incident.traitementPP.id,
              'typeModif': 'backToDpc',
              'utilisateur_createur_id': getUser().id,
            };
            this.$store.commit('IS_LOADING', true);
            data.status_id = this.$parent.$parent.$parent.statusEnAttente.id;
            this.$axios
              .post('/espaceGestion/incidents/edit/'+incident.id, data)
              .then((response) => {
                this.$store.commit('IS_LOADING', false);
                this.manageChange();
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Modification avec succès',
                  text: 'L\'incident a bien été modifié',
                  showConfirmButton: false,
                  timer: 3000
                });
              })
              .catch((error) => {
                self.$store.commit('IS_LOADING', false);
                console.log(error)
                let errorText = 'Une erreur est survenue lors de la modification de l\'incident. Si le problème persiste, merci de faire un ticket au support DOSI.';
                // if (error.response.status === 409) { errorText = 'Ce type d\'incident est déjà ouvert' }
                self.$swal({
                  position: 'top',
                  type:'error',
                  title:'Attention !!',
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                });
              });
          }
        })
      },
      clearFormDpcMail() {
        this.mailTo = ''
        this.mailSubject = ''
        this.mailBody = ''
        this.mailCc = ''
        this.documentsNeeded = ''
        this.commentaireDocBS = ''
        this.commentaireDocDecompteSS = ''
        this.periodeDateDebut = null
        this.periodeDateFin = null
        this.arretDate = null
        this.incidentSelected = null
        this.incidentId = ''
        this.dpcMailId = ''
        this.dpcId = ''
        this.dpcMailToContinue = {}
        this.selecteddpcMailModele = ''
        this.selecteddpcCevModele = ''
        this.dpcAttachments = []
        this.pjRelanceDeces = []
      },
      clearErrors() {
        this.errors.typeDpc = ''
        this.errors.attachment = ''
        this.errors.periodeDateDebut = ''
        this.errors.periodeDateFin = ''
        this.errors.arretDate = ''
        this.errors.documentsNeeded = ''
      },
      clearSelectedError(error) {
        this.errors[error] = ''
      },
      canUpload(item) {
        return !isEmpty(item.dpc) && item.dpc.type_dpc === 'courrier' && item.dpc.sent_at === null
      },
      canContinue(item) {
        let can = false
          if (item.dpc && (item.dpc.type_dpc === 'mail' || item.dpc.type_dpc === 'cev')) {
            for (let dpcMail of item.dpc.dpc_mails) {
              if (dpcMail.is_sent === false && !(dpcMail.wait_for_validation && !(this.isResponsable() || this.canValidateDpc()))) {
                if(dpcMail.dpc_mail_modele){
                  if(dpcMail.dpc_mail_modele.type_model != 'relance'){
                    can = true
                  }
                }
              }
            }
          }
        return can
      },
      canContinueReminder(item) {
        let can = false
        
        if (item.dpc && (item.dpc.type_dpc === 'mail' || item.dpc.type_dpc === 'cev' || item.dpc.type_dpc === 'courrier')) {
          for (let dpcMail of item.dpc.dpc_mails) {
            if (dpcMail.is_sent === false && !(dpcMail.wait_for_validation && !(this.isResponsable() || this.canValidateDpc()))) {
              if(dpcMail.dpc_mail_modele){
                if(dpcMail.dpc_mail_modele.type_model === 'relance'){
                  can = true
                }
              }
            }
          }
        }
      
        return can
      },
      canUploadDbco(incident) {
        // console.log(incident)
        return (this.dossier.accuse_reception === 'ar_courrier' || (this.dossier.type_support === 'papier' && this.dbcoIsConforme === 'false' && this.dossier.accuse_reception !== 'ar_mail')) && !incident.can_edit
      },
      showUploadDbco(incident) {
        // let traitementId = this.$route.query.traitementId;
        // let statusDossier = _.find(this.dossier.status, function (element) {
        //   return parseInt(element.pivot.traitement_id,10) === parseInt(traitementId,10);
        // });

        // return this.$parent.$parent.$parent.isConformiteDBCO  && statusDossier && this.$parent.$parent.$parent.statusTraiteIds.indexOf(statusDossier.id) === -1 && statusDossier.libelle_technique !== 'en_attente_validation_dbco' && (this.dossier.accuse_reception === 'ar_courrier' || (this.dossier.type_support === 'papier' && this.dbcoIsConforme === 'false' && this.dossier.accuse_reception !== 'ar_mail')) && !incident.can_edit;

        return false;
      },
      checkCanContinueDbco(incident) {
        return !isEmpty(incident.statusPP)
        && ((incident.statusPP.libelle_technique === 'a_traiter_en_cours_conformite_dbco' && this.currentTreatment.libelle_technique === 'gestion_dbco') || (incident.statusPP.libelle_technique === 'en_attente_validation_dbco' && this.currentTreatment.libelle_technique === 'validation_dbco'))
        && (this.dossier.accuse_reception === 'ar_mail' || (
              ((this.dbcoIsConforme === 'false' || this.dbcoIsConforme === false) && this.dossier.accuse_reception === 'ar_mail')
              || (this.dossier.type_support === 'papier' && this.dossier.accuse_reception === 'ar_mail')
            )
        );
      },
      canDeleteDpcPj(type) {
        if (type === 'dbco') {
          let traitementId = this.$route.query.traitementId;
          let statusDossier = _.find(this.dossier.status, function (element) {
            return parseInt(element.pivot.traitement_id,10) === parseInt(traitementId,10);
          });
          return this.$parent.$parent.$parent.statusTraiteIds.indexOf(statusDossier.id) === -1;
        }
        return this.dpcMailToContinue.is_sent === false && (this.dpcMailToContinue.wait_for_validation === false || (this.dpcMailToContinue.wait_for_validation === true && this.isResponsable()))
      },
      canDoReminder(incident, isRelanceAnnuelle) {
        let can = false
        let showRelanceAnnuelle = false
        if (hasRule(rules.CAN_EXECUTE_RELANCE_DPC)) {
          if (!isEmpty(incident.dpc) && !isEmpty(incident.dpc.reminder3_at)) {
            let dateRelance3 = new Date(moment(incident.dpc.reminder3_at))
            if (!isEmpty(dateRelance3)) {
              showRelanceAnnuelle = true
            }
          }
          let condition = isRelanceAnnuelle !== true ? (incident.dpc && incident.dpc.sent_at !== null) : (showRelanceAnnuelle === true && this.dossier.type && this.dossier.type.groupe.toLowerCase() == 'dc' && incident.dpc && incident.dpc.reminder3_at !== null)
          // On change le test pour ne plus bloquer l'envoie de relance maintenant que la date de relance est enregistrée en fonction du modèle choisi
          // if (incident.dpc && incident.dpc.sent_at !== null && incident.dpc.dpc_mails.length >= 1 && incident.dpc.dpc_mails.length < 4) {
          if (condition) {
            let dpcMailEnCours = false
            for (let mail of incident.dpc.dpc_mails) {
              if (mail.is_sent === false || (mail.is_sent === false && incident.dpc.type_dpc === 'cev')) {
                dpcMailEnCours = true
              }
            }
            can = !dpcMailEnCours && parseInt(incident.statut,10) !== 0
          }
        }
        return can
      },
      canSeeSentMail(incident) {
        return (incident.dpc && incident.dpc.sent_at !== null && incident.dpc.type_dpc !== 'courrier') || (!isEmpty(incident.statusPP) && incident.statusPP.libelle_technique === 'dpc_a_valider' && !(this.isResponsable() || this.canValidateDpc()))
      },
      canShowSentMailDbco(incident) {
        return (incident.mailConformite && incident.mailConformite.sent_at !== null);
        // return ((incident.mailConformite && incident.mailConformite.sent_at !== null) || (!isEmpty(incident.statusPP) && incident.statusPP.libelle_technique === 'en_attente_validation_dbco' && this.dossier.accuse_reception === 'ar_mail'));
      },
      checkCanValidateDbcoSansAr(incident) {
        // On ajoute le cas de la validation ar_courrier
        return !isEmpty(incident.statusPP)
              // && this.isResponsable()
              && incident.statusPP.libelle_technique === 'en_attente_validation_dbco'
              && this.currentTreatment.libelle_technique === 'validation_dbco'
              && (this.dossier.accuse_reception === 'ar_sans' || this.dossier.accuse_reception ===  'ar_non_renseigne' || this.dossier.accuse_reception === 'ar_courrier');
      },
      showDpcAgain(incident) {
        let statusRetourDpc = this.$parent.$parent.$parent.statusATraiter.sous_statuts.reduce((res,status) => {
          return status.libelle_technique === 'a_traiter_retour_dpc' ? status : res;
        },{id: null})
        return (isEmpty(incident.traitementPS) && parseInt(incident.sousStatut,10) === parseInt(statusRetourDpc.id,10)) && (incident.dpc.type_dpc !== 'cev');
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      dateTimeToString(dateTime) {
        return dateTime.replace(/ /g,'').replace(/-/g,'').replace(/:/g,'')
      },
      formatNames(files) {
        if (files.length === 1) {
          return files[0].name
        } else {
          return `${files.length} fichiers selectionnés`
        }
      },
      getIconSrcPj(data) {
        let pj = data
        if (typeof data !== 'object') {
          pj = this.pieces_jointes.find(pj => pj.id === data)
        }
        // console.log('dans le getsrcIcon', pj)
        return getIconSrcMain(pj)
      },
      getPjName(pjId) {
        let pj = this.pieces_jointes.find(pj => pj.id === pjId)
        return !isEmpty(pj) ? pj.name : ''
      },
      getReadableFileSize(size) {
        return getReadableFileSizeMain(size)
      },
      isTreatment(libelle_technique) {
        let treatment = _.find(this.traitements, (element) => element.libelle_technique === libelle_technique );
        return isEmpty(treatment) ? false : parseInt(this.$route.query.traitementId,10) === treatment.id
      },
      getCurrentTreatment() {
        this.currentTreatment = this.traitements.reduce((res,treatment) => {
          return treatment.id === parseInt(this.$route.query.traitementId,10) ? treatment : res;
        },{});
      },
      getMainDossierTraitementId() {
        let traitementId = '';
        let mainTreatment = getMainTreatmentBasedOnType(this.dossier, this.traitements);

        traitementId = mainTreatment.id;

        return traitementId;
      },
      getIconSrc(type, dossier) {
        let images = require.context('@/assets/images/', false, /\.png$/)
        let icon = ''

        if (type === 'corner') {
          icon = 'corner-top-right-10.png'
        }

        return images('./' + icon)
      },
      timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      openIncidentAnomalieModal(incident) {
        this.clearInfoQualiteModal();
        this.motifAnomalieControle = incident.motifPrincipal;
        this.resultatControle = incident.resultatControle;
        this.commentaireControle = incident.commentaireControle;
        this.$refs['modal-info-qualite'].show();
      },
      clearInfoQualiteModal() {
        this.motifAnomalieControle = null;
        this.resultatControle = null;
        this.commentaireControle = null;
      },
      enregistrerCommentaire() {
        let self = this;
        let postData = {
          dossierId: this.dossier.id,
          commentaireIncident: this.myData.commentaire
        };
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/dossier/commentaire/incident', postData)
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            this.$event.emit('refreshDossier');
            this.myData.commentaire = '';
            this.$swal({
              position: 'top',
              type: 'success',
              title: 'Succès',
              text: 'Commentaire enregistré avec succès',
              showConfirmButton: false,
              timer: 3000
            })
          })
          .catch((error) => {
            let errorText = 'Une erreur est survenue lors de l\'enregistrement du commentaire. Si le problème persiste, merci de faire un ticket au support DOSI.'
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            })
          }).finally(() => this.$store.commit('IS_LOADING', false));
      },
      async sendArDbcoAgain(incident) {
        if (this.contactHasChanged()) {
          this.$swal
            .fire({
              title: 'Êtes-vous sûr?',
              text: "Voulez-vous renvoyer l'accusé de réception à la nouvelle adresse mail ?",
              type: 'warning',
              reverseButtons: false,
              showCancelButton: true,
              cancelButtonColor: "#ff1744",
              confirmButtonText: 'Enregistrer',
              cancelButtonText: 'Annuler',
            })
            .then(async (result) => {
              if (result.value === true) {
                await this.$parent.$parent.$parent.save('save');
                let self = this;

                this.$store.commit('IS_LOADING', true)
                this.$axios
                  .get('/espaceGestion/incidents/dbco/resendAr/'+incident.id)
                  .then((response) => {
                    this.$store.commit('IS_LOADING', false)

                    let textSwal = 'L\'accusé de réception a bien été envoyé à la nouvelle adresse mail';
                    this.$swal({
                      position: 'top',
                      type: 'success',
                      title: 'Création avec succès',
                      text: textSwal,
                      showConfirmButton: false,
                      timer: 3000
                    })
                  })
                  .catch((error) => {
                    self.$store.commit('IS_LOADING', false)
                    console.log(error)
                    let errorText = 'Une erreur est survenue lors du nouvel envoie de \'accusé de réception à la nouvelle adresse mail. Si le problème persiste, merci de faire un ticket au support DOSI.';
                    self.$swal({
                      position: 'top',
                      type:'error',
                      title:'Attention !!',
                      text:errorText,
                      showConfirmButton: false,
                      timer: 5000
                    })
                  })
              }
            });
        } else {
          // console.log('il n y a pas eu de changement ERROR')
          let errorText = 'Vous devez modifier l\'adresse mail ou l\'adresse postale.'
          this.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: errorText,
            showConfirmButton: false,
            timer: 5000
          });
        }
      },
      contactHasChanged() {
        // console.log('this.dossier.adresse1, this.$parent.adresse1',this.dossier.adresse1, this.$parent.$parent.$parent.adresse1)
        // console.log('this.dossier.adresse2, this.$parent.adresse2',this.dossier.adresse2, this.$parent.$parent.$parent.adresse2)
        // console.log('this.dossier.email, this.$parent.email',this.dossier.email, this.$parent.$parent.$parent.email)
        return this.dossier.adresse1 !== this.$parent.$parent.$parent.adresse1 || this.dossier.adresse2 !== this.$parent.$parent.$parent.adresse2 || this.dossier.email !== this.$parent.$parent.$parent.email;
      },
      getLibelleDocumentDemande(askedDocument, type) {
        let libelle = '<b>' + askedDocument.libelle_court + '</b>';

        if (type === 'creation') {
          if (askedDocument.libelle_technique === 'decomptes_ss') {
            libelle = libelle + ' : <div class="pl-3">' + nl2br(this.commentaireDocDecompteSS) + '</div>';
          } else if (askedDocument.libelle_technique === 'bulletins_salaire') {
            libelle = libelle + ' : <div class="pl-3">' + nl2br(this.commentaireDocBS) + '</div>';
          }
        } else {
          if (!isEmpty(askedDocument.pivot.commentaire)) {
            libelle = libelle + ' : <div class="pl-3">' + nl2br(askedDocument.pivot.commentaire) + '</div>';
          }
        }

        return libelle;
      },
      reducedFileName(name) {
        if (name.length > 53) {
          return name.substring(0, 50) + ' ...';
        } else {
          return name;
        }
      },
      cancelRelanceAjoutPj() {
        this.pjRelanceDeces = [];
        this.$refs['modal-relance-ajout-pj'].hide();
      },
      SaveRelanceAjoutPj() {
        this.$refs['modal-relance-ajout-pj'].hide();
        this.$refs['modal-mail-dpc'].show();
      },
      cantEditFicheDC
    }
  };
</script>
<style scoped>
  table {
    width: 100%;
    overflow-x: auto;
  }

</style>
<style type="text/css">
  .ck.ck-editor {
    width: 100% !important;
  }
  .no-padding {
    padding: 0;
  }
  .no-decoration {
    list-style: none;
  }
  .icon-size-16 {
    width: 16px;
  }
  .fa-1-5x {
    font-size: 1.5em;
  }
  #table-incident {
    font-size: 0.8rem;
  }
  tr td.tooltip-cell {
    position: relative;
    vertical-align: middle;
  }
  tr td.tooltip-cell img {
    position: absolute;
    top: 0;
    right: 0;
  }
  tr.small-padding-y td {
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
  }
  .table th, .table td {
    vertical-align: middle;
  }
  tr.b-table-details td {
    padding-top: 0.5rem;
  }
  /*@page
  {
      size:  auto;
      margin: 0mm;
  }

  @media screen {
    #print {
      display: none;
     }
  }

  @media print {
   body * {
      visibility:hidden;
    }
    #print, #print * {
      visibility:visible;
    }
    #print {
      position:absolute;
      left:0;
      top:0;
      width: 100%;
      height: 100%;
      font-size: 20px;

      line-height: 22px;
    }

    .print_dbco_adresse {
      position: absolute;
      top: 200px;
      left: 500px;
    }

    .print_dbco_text {
      position: absolute;
      top: 450px;

      margin-left: 25mm;
      margin-right: 25mm;
    }
  }*/
</style>
